/*
 * Flickity PACKAGED v2.2.1
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2019 Metafizzy
 */
// prettier-ignore
!function(e,i){"function"==typeof define&&define.amd?define("jquery-bridget/jquery-bridget",["jquery"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("jquery")):e.jQueryBridget=i(e,e.jQuery)}(window,function(t,e){"use strict";var i=Array.prototype.slice,n=t.console,d=void 0===n?function(){}:function(t){n.error(t)};function s(h,s,c){(c=c||e||t.jQuery)&&(s.prototype.option||(s.prototype.option=function(t){c.isPlainObject(t)&&(this.options=c.extend(!0,this.options,t))}),c.fn[h]=function(t){return"string"==typeof t?function(t,o,r){var a,l="$()."+h+'("'+o+'")';return t.each(function(t,e){var i=c.data(e,h);if(i){var n=i[o];if(n&&"_"!=o.charAt(0)){var s=n.apply(i,r);a=void 0===a?s:a}else d(l+" is not a valid method")}else d(h+" not initialized. Cannot call methods, i.e. "+l)}),void 0!==a?a:t}(this,t,i.call(arguments,1)):(function(t,n){t.each(function(t,e){var i=c.data(e,h);i?(i.option(n),i._init()):(i=new s(e,n),c.data(e,h,i))})}(this,t),this)},o(c))}function o(t){!t||t&&t.bridget||(t.bridget=s)}return o(e||t.jQuery),s}),function(t,e){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",e):"object"==typeof module&&module.exports?module.exports=e():t.EvEmitter=e()}("undefined"!=typeof window?window:this,function(){function t(){}var e=t.prototype;return e.on=function(t,e){if(t&&e){var i=this._events=this._events||{},n=i[t]=i[t]||[];return-1==n.indexOf(e)&&n.push(e),this}},e.once=function(t,e){if(t&&e){this.on(t,e);var i=this._onceEvents=this._onceEvents||{};return(i[t]=i[t]||{})[e]=!0,this}},e.off=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=i.indexOf(e);return-1!=n&&i.splice(n,1),this}},e.emitEvent=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){i=i.slice(0),e=e||[];for(var n=this._onceEvents&&this._onceEvents[t],s=0;s<i.length;s++){var o=i[s];n&&n[o]&&(this.off(t,o),delete n[o]),o.apply(this,e)}return this}},e.allOff=function(){delete this._events,delete this._onceEvents},t}),function(t,e){"function"==typeof define&&define.amd?define("get-size/get-size",e):"object"==typeof module&&module.exports?module.exports=e():t.getSize=e()}(window,function(){"use strict";function m(t){var e=parseFloat(t);return-1==t.indexOf("%")&&!isNaN(e)&&e}var i="undefined"==typeof console?function(){}:function(t){console.error(t)},y=["paddingLeft","paddingRight","paddingTop","paddingBottom","marginLeft","marginRight","marginTop","marginBottom","borderLeftWidth","borderRightWidth","borderTopWidth","borderBottomWidth"],b=y.length;function E(t){var e=getComputedStyle(t);return e||i("Style returned "+e+". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"),e}var S,C=!1;function x(t){if(function(){if(!C){C=!0;var t=document.createElement("div");t.style.width="200px",t.style.padding="1px 2px 3px 4px",t.style.borderStyle="solid",t.style.borderWidth="1px 2px 3px 4px",t.style.boxSizing="border-box";var e=document.body||document.documentElement;e.appendChild(t);var i=E(t);S=200==Math.round(m(i.width)),x.isBoxSizeOuter=S,e.removeChild(t)}}(),"string"==typeof t&&(t=document.querySelector(t)),t&&"object"==typeof t&&t.nodeType){var e=E(t);if("none"==e.display)return function(){for(var t={width:0,height:0,innerWidth:0,innerHeight:0,outerWidth:0,outerHeight:0},e=0;e<b;e++){t[y[e]]=0}return t}();var i={};i.width=t.offsetWidth,i.height=t.offsetHeight;for(var n=i.isBorderBox="border-box"==e.boxSizing,s=0;s<b;s++){var o=y[s],r=e[o],a=parseFloat(r);i[o]=isNaN(a)?0:a}var l=i.paddingLeft+i.paddingRight,h=i.paddingTop+i.paddingBottom,c=i.marginLeft+i.marginRight,d=i.marginTop+i.marginBottom,u=i.borderLeftWidth+i.borderRightWidth,f=i.borderTopWidth+i.borderBottomWidth,p=n&&S,g=m(e.width);!1!==g&&(i.width=g+(p?0:l+u));var v=m(e.height);return!1!==v&&(i.height=v+(p?0:h+f)),i.innerWidth=i.width-(l+u),i.innerHeight=i.height-(h+f),i.outerWidth=i.width+c,i.outerHeight=i.height+d,i}}return x}),function(t,e){"use strict";"function"==typeof define&&define.amd?define("desandro-matches-selector/matches-selector",e):"object"==typeof module&&module.exports?module.exports=e():t.matchesSelector=e()}(window,function(){"use strict";var i=function(){var t=window.Element.prototype;if(t.matches)return"matches";if(t.matchesSelector)return"matchesSelector";for(var e=["webkit","moz","ms","o"],i=0;i<e.length;i++){var n=e[i]+"MatchesSelector";if(t[n])return n}}();return function(t,e){return t[i](e)}}),function(e,i){"function"==typeof define&&define.amd?define("fizzy-ui-utils/utils",["desandro-matches-selector/matches-selector"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("desandro-matches-selector")):e.fizzyUIUtils=i(e,e.matchesSelector)}(window,function(h,o){var c={extend:function(t,e){for(var i in e)t[i]=e[i];return t},modulo:function(t,e){return(t%e+e)%e}},e=Array.prototype.slice;c.makeArray=function(t){return Array.isArray(t)?t:null==t?[]:"object"==typeof t&&"number"==typeof t.length?e.call(t):[t]},c.removeFrom=function(t,e){var i=t.indexOf(e);-1!=i&&t.splice(i,1)},c.getParent=function(t,e){for(;t.parentNode&&t!=document.body;)if(t=t.parentNode,o(t,e))return t},c.getQueryElement=function(t){return"string"==typeof t?document.querySelector(t):t},c.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},c.filterFindElements=function(t,n){t=c.makeArray(t);var s=[];return t.forEach(function(t){if(t instanceof HTMLElement)if(n){o(t,n)&&s.push(t);for(var e=t.querySelectorAll(n),i=0;i<e.length;i++)s.push(e[i])}else s.push(t)}),s},c.debounceMethod=function(t,e,n){n=n||100;var s=t.prototype[e],o=e+"Timeout";t.prototype[e]=function(){var t=this[o];clearTimeout(t);var e=arguments,i=this;this[o]=setTimeout(function(){s.apply(i,e),delete i[o]},n)}},c.docReady=function(t){var e=document.readyState;"complete"==e||"interactive"==e?setTimeout(t):document.addEventListener("DOMContentLoaded",t)},c.toDashed=function(t){return t.replace(/(.)([A-Z])/g,function(t,e,i){return e+"-"+i}).toLowerCase()};var d=h.console;return c.htmlInit=function(a,l){c.docReady(function(){var t=c.toDashed(l),s="data-"+t,e=document.querySelectorAll("["+s+"]"),i=document.querySelectorAll(".js-"+t),n=c.makeArray(e).concat(c.makeArray(i)),o=s+"-options",r=h.jQuery;n.forEach(function(e){var t,i=e.getAttribute(s)||e.getAttribute(o);try{t=i&&JSON.parse(i)}catch(t){return void(d&&d.error("Error parsing "+s+" on "+e.className+": "+t))}var n=new a(e,t);r&&r.data(e,l,n)})})},c}),function(e,i){"function"==typeof define&&define.amd?define("flickity/js/cell",["get-size/get-size"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("get-size")):(e.Flickity=e.Flickity||{},e.Flickity.Cell=i(e,e.getSize))}(window,function(t,e){function i(t,e){this.element=t,this.parent=e,this.create()}var n=i.prototype;return n.create=function(){this.element.style.position="absolute",this.element.setAttribute("aria-hidden","true"),this.x=0,this.shift=0},n.destroy=function(){this.unselect(),this.element.style.position="";var t=this.parent.originSide;this.element.style[t]=""},n.getSize=function(){this.size=e(this.element)},n.setPosition=function(t){this.x=t,this.updateTarget(),this.renderPosition(t)},n.updateTarget=n.setDefaultTarget=function(){var t="left"==this.parent.originSide?"marginLeft":"marginRight";this.target=this.x+this.size[t]+this.size.width*this.parent.cellAlign},n.renderPosition=function(t){var e=this.parent.originSide;this.element.style[e]=this.parent.getPositionValue(t)},n.select=function(){this.element.classList.add("is-selected"),this.element.removeAttribute("aria-hidden")},n.unselect=function(){this.element.classList.remove("is-selected"),this.element.setAttribute("aria-hidden","true")},n.wrapShift=function(t){this.shift=t,this.renderPosition(this.x+this.parent.slideableWidth*t)},n.remove=function(){this.element.parentNode.removeChild(this.element)},i}),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/slide",e):"object"==typeof module&&module.exports?module.exports=e():(t.Flickity=t.Flickity||{},t.Flickity.Slide=e())}(window,function(){"use strict";function t(t){this.parent=t,this.isOriginLeft="left"==t.originSide,this.cells=[],this.outerWidth=0,this.height=0}var e=t.prototype;return e.addCell=function(t){if(this.cells.push(t),this.outerWidth+=t.size.outerWidth,this.height=Math.max(t.size.outerHeight,this.height),1==this.cells.length){this.x=t.x;var e=this.isOriginLeft?"marginLeft":"marginRight";this.firstMargin=t.size[e]}},e.updateTarget=function(){var t=this.isOriginLeft?"marginRight":"marginLeft",e=this.getLastCell(),i=e?e.size[t]:0,n=this.outerWidth-(this.firstMargin+i);this.target=this.x+this.firstMargin+n*this.parent.cellAlign},e.getLastCell=function(){return this.cells[this.cells.length-1]},e.select=function(){this.cells.forEach(function(t){t.select()})},e.unselect=function(){this.cells.forEach(function(t){t.unselect()})},e.getCellElements=function(){return this.cells.map(function(t){return t.element})},t}),function(e,i){"function"==typeof define&&define.amd?define("flickity/js/animate",["fizzy-ui-utils/utils"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("fizzy-ui-utils")):(e.Flickity=e.Flickity||{},e.Flickity.animatePrototype=i(e,e.fizzyUIUtils))}(window,function(t,e){var i={startAnimation:function(){this.isAnimating||(this.isAnimating=!0,this.restingFrames=0,this.animate())},animate:function(){this.applyDragForce(),this.applySelectedAttraction();var t=this.x;if(this.integratePhysics(),this.positionSlider(),this.settle(t),this.isAnimating){var e=this;requestAnimationFrame(function(){e.animate()})}},positionSlider:function(){var t=this.x;this.options.wrapAround&&1<this.cells.length&&(t=e.modulo(t,this.slideableWidth),t-=this.slideableWidth,this.shiftWrapCells(t)),this.setTranslateX(t,this.isAnimating),this.dispatchScrollEvent()},setTranslateX:function(t,e){t+=this.cursorPosition,t=this.options.rightToLeft?-t:t;var i=this.getPositionValue(t);this.slider.style.transform=e?"translate3d("+i+",0,0)":"translateX("+i+")"},dispatchScrollEvent:function(){var t=this.slides[0];if(t){var e=-this.x-t.target,i=e/this.slidesWidth;this.dispatchEvent("scroll",null,[i,e])}},positionSliderAtSelected:function(){this.cells.length&&(this.x=-this.selectedSlide.target,this.velocity=0,this.positionSlider())},getPositionValue:function(t){return this.options.percentPosition?.01*Math.round(t/this.size.innerWidth*1e4)+"%":Math.round(t)+"px"},settle:function(t){this.isPointerDown||Math.round(100*this.x)!=Math.round(100*t)||this.restingFrames++,2<this.restingFrames&&(this.isAnimating=!1,delete this.isFreeScrolling,this.positionSlider(),this.dispatchEvent("settle",null,[this.selectedIndex]))},shiftWrapCells:function(t){var e=this.cursorPosition+t;this._shiftCells(this.beforeShiftCells,e,-1);var i=this.size.innerWidth-(t+this.slideableWidth+this.cursorPosition);this._shiftCells(this.afterShiftCells,i,1)},_shiftCells:function(t,e,i){for(var n=0;n<t.length;n++){var s=t[n],o=0<e?i:0;s.wrapShift(o),e-=s.size.outerWidth}},_unshiftCells:function(t){if(t&&t.length)for(var e=0;e<t.length;e++)t[e].wrapShift(0)},integratePhysics:function(){this.x+=this.velocity,this.velocity*=this.getFrictionFactor()},applyForce:function(t){this.velocity+=t},getFrictionFactor:function(){return 1-this.options[this.isFreeScrolling?"freeScrollFriction":"friction"]},getRestingPosition:function(){return this.x+this.velocity/(1-this.getFrictionFactor())},applyDragForce:function(){if(this.isDraggable&&this.isPointerDown){var t=this.dragX-this.x-this.velocity;this.applyForce(t)}},applySelectedAttraction:function(){if(!(this.isDraggable&&this.isPointerDown)&&!this.isFreeScrolling&&this.slides.length){var t=(-1*this.selectedSlide.target-this.x)*this.options.selectedAttraction;this.applyForce(t)}}};return i}),function(r,a){if("function"==typeof define&&define.amd)define("flickity/js/flickity",["ev-emitter/ev-emitter","get-size/get-size","fizzy-ui-utils/utils","./cell","./slide","./animate"],function(t,e,i,n,s,o){return a(r,t,e,i,n,s,o)});else if("object"==typeof module&&module.exports)module.exports=a(r,require("ev-emitter"),require("get-size"),require("fizzy-ui-utils"),require("./cell"),require("./slide"),require("./animate"));else{var t=r.Flickity;r.Flickity=a(r,r.EvEmitter,r.getSize,r.fizzyUIUtils,t.Cell,t.Slide,t.animatePrototype)}}(window,function(n,t,e,a,i,r,s){var l=n.jQuery,o=n.getComputedStyle,h=n.console;function c(t,e){for(t=a.makeArray(t);t.length;)e.appendChild(t.shift())}var d=0,u={};function f(t,e){var i=a.getQueryElement(t);if(i){if(this.element=i,this.element.flickityGUID){var n=u[this.element.flickityGUID];return n.option(e),n}l&&(this.$element=l(this.element)),this.options=a.extend({},this.constructor.defaults),this.option(e),this._create()}else h&&h.error("Bad element for Flickity: "+(i||t))}f.defaults={accessibility:!0,cellAlign:"center",freeScrollFriction:.075,friction:.28,namespaceJQueryEvents:!0,percentPosition:!0,resize:!0,selectedAttraction:.025,setGallerySize:!0},f.createMethods=[];var p=f.prototype;a.extend(p,t.prototype),p._create=function(){var t=this.guid=++d;for(var e in this.element.flickityGUID=t,(u[t]=this).selectedIndex=0,this.restingFrames=0,this.x=0,this.velocity=0,this.originSide=this.options.rightToLeft?"right":"left",this.viewport=document.createElement("div"),this.viewport.className="flickity-viewport",this._createSlider(),(this.options.resize||this.options.watchCSS)&&n.addEventListener("resize",this),this.options.on){var i=this.options.on[e];this.on(e,i)}f.createMethods.forEach(function(t){this[t]()},this),this.options.watchCSS?this.watchCSS():this.activate()},p.option=function(t){a.extend(this.options,t)},p.activate=function(){this.isActive||(this.isActive=!0,this.element.classList.add("flickity-enabled"),this.options.rightToLeft&&this.element.classList.add("flickity-rtl"),this.getSize(),c(this._filterFindCellElements(this.element.children),this.slider),this.viewport.appendChild(this.slider),this.element.appendChild(this.viewport),this.reloadCells(),this.options.accessibility&&(this.element.tabIndex=0,this.element.addEventListener("keydown",this)),this.emitEvent("activate"),this.selectInitialIndex(),this.isInitActivated=!0,this.dispatchEvent("ready"))},p._createSlider=function(){var t=document.createElement("div");t.className="flickity-slider",t.style[this.originSide]=0,this.slider=t},p._filterFindCellElements=function(t){return a.filterFindElements(t,this.options.cellSelector)},p.reloadCells=function(){this.cells=this._makeCells(this.slider.children),this.positionCells(),this._getWrapShiftCells(),this.setGallerySize()},p._makeCells=function(t){return this._filterFindCellElements(t).map(function(t){return new i(t,this)},this)},p.getLastCell=function(){return this.cells[this.cells.length-1]},p.getLastSlide=function(){return this.slides[this.slides.length-1]},p.positionCells=function(){this._sizeCells(this.cells),this._positionCells(0)},p._positionCells=function(t){t=t||0,this.maxCellHeight=t&&this.maxCellHeight||0;var e=0;if(0<t){var i=this.cells[t-1];e=i.x+i.size.outerWidth}for(var n=this.cells.length,s=t;s<n;s++){var o=this.cells[s];o.setPosition(e),e+=o.size.outerWidth,this.maxCellHeight=Math.max(o.size.outerHeight,this.maxCellHeight)}this.slideableWidth=e,this.updateSlides(),this._containSlides(),this.slidesWidth=n?this.getLastSlide().target-this.slides[0].target:0},p._sizeCells=function(t){t.forEach(function(t){t.getSize()})},p.updateSlides=function(){if(this.slides=[],this.cells.length){var n=new r(this);this.slides.push(n);var s="left"==this.originSide?"marginRight":"marginLeft",o=this._getCanCellFit();this.cells.forEach(function(t,e){if(n.cells.length){var i=n.outerWidth-n.firstMargin+(t.size.outerWidth-t.size[s]);o.call(this,e,i)||(n.updateTarget(),n=new r(this),this.slides.push(n)),n.addCell(t)}else n.addCell(t)},this),n.updateTarget(),this.updateSelectedSlide()}},p._getCanCellFit=function(){var t=this.options.groupCells;if(!t)return function(){return!1};if("number"==typeof t){var e=parseInt(t,10);return function(t){return t%e!=0}}var i="string"==typeof t&&t.match(/^(\d+)%$/),n=i?parseInt(i[1],10)/100:1;return function(t,e){return e<=(this.size.innerWidth+1)*n}},p._init=p.reposition=function(){this.positionCells(),this.positionSliderAtSelected()},p.getSize=function(){this.size=e(this.element),this.setCellAlign(),this.cursorPosition=this.size.innerWidth*this.cellAlign};var g={center:{left:.5,right:.5},left:{left:0,right:1},right:{right:0,left:1}};return p.setCellAlign=function(){var t=g[this.options.cellAlign];this.cellAlign=t?t[this.originSide]:this.options.cellAlign},p.setGallerySize=function(){if(this.options.setGallerySize){var t=this.options.adaptiveHeight&&this.selectedSlide?this.selectedSlide.height:this.maxCellHeight;this.viewport.style.height=t+"px"}},p._getWrapShiftCells=function(){if(this.options.wrapAround){this._unshiftCells(this.beforeShiftCells),this._unshiftCells(this.afterShiftCells);var t=this.cursorPosition,e=this.cells.length-1;this.beforeShiftCells=this._getGapCells(t,e,-1),t=this.size.innerWidth-this.cursorPosition,this.afterShiftCells=this._getGapCells(t,0,1)}},p._getGapCells=function(t,e,i){for(var n=[];0<t;){var s=this.cells[e];if(!s)break;n.push(s),e+=i,t-=s.size.outerWidth}return n},p._containSlides=function(){if(this.options.contain&&!this.options.wrapAround&&this.cells.length){var t=this.options.rightToLeft,e=t?"marginRight":"marginLeft",i=t?"marginLeft":"marginRight",n=this.slideableWidth-this.getLastCell().size[i],s=n<this.size.innerWidth,o=this.cursorPosition+this.cells[0].size[e],r=n-this.size.innerWidth*(1-this.cellAlign);this.slides.forEach(function(t){s?t.target=n*this.cellAlign:(t.target=Math.max(t.target,o),t.target=Math.min(t.target,r))},this)}},p.dispatchEvent=function(t,e,i){var n=e?[e].concat(i):i;if(this.emitEvent(t,n),l&&this.$element){var s=t+=this.options.namespaceJQueryEvents?".flickity":"";if(e){var o=l.Event(e);o.type=t,s=o}this.$element.trigger(s,i)}},p.select=function(t,e,i){if(this.isActive&&(t=parseInt(t,10),this._wrapSelect(t),(this.options.wrapAround||e)&&(t=a.modulo(t,this.slides.length)),this.slides[t])){var n=this.selectedIndex;this.selectedIndex=t,this.updateSelectedSlide(),i?this.positionSliderAtSelected():this.startAnimation(),this.options.adaptiveHeight&&this.setGallerySize(),this.dispatchEvent("select",null,[t]),t!=n&&this.dispatchEvent("change",null,[t]),this.dispatchEvent("cellSelect")}},p._wrapSelect=function(t){var e=this.slides.length;if(!(this.options.wrapAround&&1<e))return t;var i=a.modulo(t,e),n=Math.abs(i-this.selectedIndex),s=Math.abs(i+e-this.selectedIndex),o=Math.abs(i-e-this.selectedIndex);!this.isDragSelect&&s<n?t+=e:!this.isDragSelect&&o<n&&(t-=e),t<0?this.x-=this.slideableWidth:e<=t&&(this.x+=this.slideableWidth)},p.previous=function(t,e){this.select(this.selectedIndex-1,t,e)},p.next=function(t,e){this.select(this.selectedIndex+1,t,e)},p.updateSelectedSlide=function(){var t=this.slides[this.selectedIndex];t&&(this.unselectSelectedSlide(),(this.selectedSlide=t).select(),this.selectedCells=t.cells,this.selectedElements=t.getCellElements(),this.selectedCell=t.cells[0],this.selectedElement=this.selectedElements[0])},p.unselectSelectedSlide=function(){this.selectedSlide&&this.selectedSlide.unselect()},p.selectInitialIndex=function(){var t=this.options.initialIndex;if(this.isInitActivated)this.select(this.selectedIndex,!1,!0);else{if(t&&"string"==typeof t)if(this.queryCell(t))return void this.selectCell(t,!1,!0);var e=0;t&&this.slides[t]&&(e=t),this.select(e,!1,!0)}},p.selectCell=function(t,e,i){var n=this.queryCell(t);if(n){var s=this.getCellSlideIndex(n);this.select(s,e,i)}},p.getCellSlideIndex=function(t){for(var e=0;e<this.slides.length;e++){if(-1!=this.slides[e].cells.indexOf(t))return e}},p.getCell=function(t){for(var e=0;e<this.cells.length;e++){var i=this.cells[e];if(i.element==t)return i}},p.getCells=function(t){t=a.makeArray(t);var i=[];return t.forEach(function(t){var e=this.getCell(t);e&&i.push(e)},this),i},p.getCellElements=function(){return this.cells.map(function(t){return t.element})},p.getParentCell=function(t){var e=this.getCell(t);return e||(t=a.getParent(t,".flickity-slider > *"),this.getCell(t))},p.getAdjacentCellElements=function(t,e){if(!t)return this.selectedSlide.getCellElements();e=void 0===e?this.selectedIndex:e;var i=this.slides.length;if(i<=1+2*t)return this.getCellElements();for(var n=[],s=e-t;s<=e+t;s++){var o=this.options.wrapAround?a.modulo(s,i):s,r=this.slides[o];r&&(n=n.concat(r.getCellElements()))}return n},p.queryCell=function(t){if("number"==typeof t)return this.cells[t];if("string"==typeof t){if(t.match(/^[#\.]?[\d\/]/))return;t=this.element.querySelector(t)}return this.getCell(t)},p.uiChange=function(){this.emitEvent("uiChange")},p.childUIPointerDown=function(t){"touchstart"!=t.type&&t.preventDefault(),this.focus()},p.onresize=function(){this.watchCSS(),this.resize()},a.debounceMethod(f,"onresize",150),p.resize=function(){if(this.isActive){this.getSize(),this.options.wrapAround&&(this.x=a.modulo(this.x,this.slideableWidth)),this.positionCells(),this._getWrapShiftCells(),this.setGallerySize(),this.emitEvent("resize");var t=this.selectedElements&&this.selectedElements[0];this.selectCell(t,!1,!0)}},p.watchCSS=function(){this.options.watchCSS&&(-1!=o(this.element,":after").content.indexOf("flickity")?this.activate():this.deactivate())},p.onkeydown=function(t){var e=document.activeElement&&document.activeElement!=this.element;if(this.options.accessibility&&!e){var i=f.keyboardHandlers[t.keyCode];i&&i.call(this)}},f.keyboardHandlers={37:function(){var t=this.options.rightToLeft?"next":"previous";this.uiChange(),this[t]()},39:function(){var t=this.options.rightToLeft?"previous":"next";this.uiChange(),this[t]()}},p.focus=function(){var t=n.pageYOffset;this.element.focus({preventScroll:!0}),n.pageYOffset!=t&&n.scrollTo(n.pageXOffset,t)},p.deactivate=function(){this.isActive&&(this.element.classList.remove("flickity-enabled"),this.element.classList.remove("flickity-rtl"),this.unselectSelectedSlide(),this.cells.forEach(function(t){t.destroy()}),this.element.removeChild(this.viewport),c(this.slider.children,this.element),this.options.accessibility&&(this.element.removeAttribute("tabIndex"),this.element.removeEventListener("keydown",this)),this.isActive=!1,this.emitEvent("deactivate"))},p.destroy=function(){this.deactivate(),n.removeEventListener("resize",this),this.allOff(),this.emitEvent("destroy"),l&&this.$element&&l.removeData(this.element,"flickity"),delete this.element.flickityGUID,delete u[this.guid]},a.extend(p,s),f.data=function(t){var e=(t=a.getQueryElement(t))&&t.flickityGUID;return e&&u[e]},a.htmlInit(f,"flickity"),l&&l.bridget&&l.bridget("flickity",f),f.setJQuery=function(t){l=t},f.Cell=i,f.Slide=r,f}),function(e,i){"function"==typeof define&&define.amd?define("unipointer/unipointer",["ev-emitter/ev-emitter"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("ev-emitter")):e.Unipointer=i(e,e.EvEmitter)}(window,function(s,t){function e(){}var i=e.prototype=Object.create(t.prototype);i.bindStartEvent=function(t){this._bindStartEvent(t,!0)},i.unbindStartEvent=function(t){this._bindStartEvent(t,!1)},i._bindStartEvent=function(t,e){var i=(e=void 0===e||e)?"addEventListener":"removeEventListener",n="mousedown";s.PointerEvent?n="pointerdown":"ontouchstart"in s&&(n="touchstart"),t[i](n,this)},i.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},i.getTouch=function(t){for(var e=0;e<t.length;e++){var i=t[e];if(i.identifier==this.pointerIdentifier)return i}},i.onmousedown=function(t){var e=t.button;e&&0!==e&&1!==e||this._pointerDown(t,t)},i.ontouchstart=function(t){this._pointerDown(t,t.changedTouches[0])},i.onpointerdown=function(t){this._pointerDown(t,t)},i._pointerDown=function(t,e){t.button||this.isPointerDown||(this.isPointerDown=!0,this.pointerIdentifier=void 0!==e.pointerId?e.pointerId:e.identifier,this.pointerDown(t,e))},i.pointerDown=function(t,e){this._bindPostStartEvents(t),this.emitEvent("pointerDown",[t,e])};var n={mousedown:["mousemove","mouseup"],touchstart:["touchmove","touchend","touchcancel"],pointerdown:["pointermove","pointerup","pointercancel"]};return i._bindPostStartEvents=function(t){if(t){var e=n[t.type];e.forEach(function(t){s.addEventListener(t,this)},this),this._boundPointerEvents=e}},i._unbindPostStartEvents=function(){this._boundPointerEvents&&(this._boundPointerEvents.forEach(function(t){s.removeEventListener(t,this)},this),delete this._boundPointerEvents)},i.onmousemove=function(t){this._pointerMove(t,t)},i.onpointermove=function(t){t.pointerId==this.pointerIdentifier&&this._pointerMove(t,t)},i.ontouchmove=function(t){var e=this.getTouch(t.changedTouches);e&&this._pointerMove(t,e)},i._pointerMove=function(t,e){this.pointerMove(t,e)},i.pointerMove=function(t,e){this.emitEvent("pointerMove",[t,e])},i.onmouseup=function(t){this._pointerUp(t,t)},i.onpointerup=function(t){t.pointerId==this.pointerIdentifier&&this._pointerUp(t,t)},i.ontouchend=function(t){var e=this.getTouch(t.changedTouches);e&&this._pointerUp(t,e)},i._pointerUp=function(t,e){this._pointerDone(),this.pointerUp(t,e)},i.pointerUp=function(t,e){this.emitEvent("pointerUp",[t,e])},i._pointerDone=function(){this._pointerReset(),this._unbindPostStartEvents(),this.pointerDone()},i._pointerReset=function(){this.isPointerDown=!1,delete this.pointerIdentifier},i.pointerDone=function(){},i.onpointercancel=function(t){t.pointerId==this.pointerIdentifier&&this._pointerCancel(t,t)},i.ontouchcancel=function(t){var e=this.getTouch(t.changedTouches);e&&this._pointerCancel(t,e)},i._pointerCancel=function(t,e){this._pointerDone(),this.pointerCancel(t,e)},i.pointerCancel=function(t,e){this.emitEvent("pointerCancel",[t,e])},e.getPointerPoint=function(t){return{x:t.pageX,y:t.pageY}},e}),function(e,i){"function"==typeof define&&define.amd?define("unidragger/unidragger",["unipointer/unipointer"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("unipointer")):e.Unidragger=i(e,e.Unipointer)}(window,function(o,t){function e(){}var i=e.prototype=Object.create(t.prototype);i.bindHandles=function(){this._bindHandles(!0)},i.unbindHandles=function(){this._bindHandles(!1)},i._bindHandles=function(t){for(var e=(t=void 0===t||t)?"addEventListener":"removeEventListener",i=t?this._touchActionValue:"",n=0;n<this.handles.length;n++){var s=this.handles[n];this._bindStartEvent(s,t),s[e]("click",this),o.PointerEvent&&(s.style.touchAction=i)}},i._touchActionValue="none",i.pointerDown=function(t,e){this.okayPointerDown(t)&&(this.pointerDownPointer=e,t.preventDefault(),this.pointerDownBlur(),this._bindPostStartEvents(t),this.emitEvent("pointerDown",[t,e]))};var s={TEXTAREA:!0,INPUT:!0,SELECT:!0,OPTION:!0},r={radio:!0,checkbox:!0,button:!0,submit:!0,image:!0,file:!0};return i.okayPointerDown=function(t){var e=s[t.target.nodeName],i=r[t.target.type],n=!e||i;return n||this._pointerReset(),n},i.pointerDownBlur=function(){var t=document.activeElement;t&&t.blur&&t!=document.body&&t.blur()},i.pointerMove=function(t,e){var i=this._dragPointerMove(t,e);this.emitEvent("pointerMove",[t,e,i]),this._dragMove(t,e,i)},i._dragPointerMove=function(t,e){var i={x:e.pageX-this.pointerDownPointer.pageX,y:e.pageY-this.pointerDownPointer.pageY};return!this.isDragging&&this.hasDragStarted(i)&&this._dragStart(t,e),i},i.hasDragStarted=function(t){return 3<Math.abs(t.x)||3<Math.abs(t.y)},i.pointerUp=function(t,e){this.emitEvent("pointerUp",[t,e]),this._dragPointerUp(t,e)},i._dragPointerUp=function(t,e){this.isDragging?this._dragEnd(t,e):this._staticClick(t,e)},i._dragStart=function(t,e){this.isDragging=!0,this.isPreventingClicks=!0,this.dragStart(t,e)},i.dragStart=function(t,e){this.emitEvent("dragStart",[t,e])},i._dragMove=function(t,e,i){this.isDragging&&this.dragMove(t,e,i)},i.dragMove=function(t,e,i){t.preventDefault(),this.emitEvent("dragMove",[t,e,i])},i._dragEnd=function(t,e){this.isDragging=!1,setTimeout(function(){delete this.isPreventingClicks}.bind(this)),this.dragEnd(t,e)},i.dragEnd=function(t,e){this.emitEvent("dragEnd",[t,e])},i.onclick=function(t){this.isPreventingClicks&&t.preventDefault()},i._staticClick=function(t,e){this.isIgnoringMouseUp&&"mouseup"==t.type||(this.staticClick(t,e),"mouseup"!=t.type&&(this.isIgnoringMouseUp=!0,setTimeout(function(){delete this.isIgnoringMouseUp}.bind(this),400)))},i.staticClick=function(t,e){this.emitEvent("staticClick",[t,e])},e.getPointerPoint=t.getPointerPoint,e}),function(n,s){"function"==typeof define&&define.amd?define("flickity/js/drag",["./flickity","unidragger/unidragger","fizzy-ui-utils/utils"],function(t,e,i){return s(n,t,e,i)}):"object"==typeof module&&module.exports?module.exports=s(n,require("./flickity"),require("unidragger"),require("fizzy-ui-utils")):n.Flickity=s(n,n.Flickity,n.Unidragger,n.fizzyUIUtils)}(window,function(i,t,e,a){a.extend(t.defaults,{draggable:">1",dragThreshold:3}),t.createMethods.push("_createDrag");var n=t.prototype;a.extend(n,e.prototype),n._touchActionValue="pan-y";var s="createTouch"in document,o=!1;n._createDrag=function(){this.on("activate",this.onActivateDrag),this.on("uiChange",this._uiChangeDrag),this.on("deactivate",this.onDeactivateDrag),this.on("cellChange",this.updateDraggable),s&&!o&&(i.addEventListener("touchmove",function(){}),o=!0)},n.onActivateDrag=function(){this.handles=[this.viewport],this.bindHandles(),this.updateDraggable()},n.onDeactivateDrag=function(){this.unbindHandles(),this.element.classList.remove("is-draggable")},n.updateDraggable=function(){">1"==this.options.draggable?this.isDraggable=1<this.slides.length:this.isDraggable=this.options.draggable,this.isDraggable?this.element.classList.add("is-draggable"):this.element.classList.remove("is-draggable")},n.bindDrag=function(){this.options.draggable=!0,this.updateDraggable()},n.unbindDrag=function(){this.options.draggable=!1,this.updateDraggable()},n._uiChangeDrag=function(){delete this.isFreeScrolling},n.pointerDown=function(t,e){this.isDraggable?this.okayPointerDown(t)&&(this._pointerDownPreventDefault(t),this.pointerDownFocus(t),document.activeElement!=this.element&&this.pointerDownBlur(),this.dragX=this.x,this.viewport.classList.add("is-pointer-down"),this.pointerDownScroll=l(),i.addEventListener("scroll",this),this._pointerDownDefault(t,e)):this._pointerDownDefault(t,e)},n._pointerDownDefault=function(t,e){this.pointerDownPointer={pageX:e.pageX,pageY:e.pageY},this._bindPostStartEvents(t),this.dispatchEvent("pointerDown",t,[e])};var r={INPUT:!0,TEXTAREA:!0,SELECT:!0};function l(){return{x:i.pageXOffset,y:i.pageYOffset}}return n.pointerDownFocus=function(t){r[t.target.nodeName]||this.focus()},n._pointerDownPreventDefault=function(t){var e="touchstart"==t.type,i="touch"==t.pointerType,n=r[t.target.nodeName];e||i||n||t.preventDefault()},n.hasDragStarted=function(t){return Math.abs(t.x)>this.options.dragThreshold},n.pointerUp=function(t,e){delete this.isTouchScrolling,this.viewport.classList.remove("is-pointer-down"),this.dispatchEvent("pointerUp",t,[e]),this._dragPointerUp(t,e)},n.pointerDone=function(){i.removeEventListener("scroll",this),delete this.pointerDownScroll},n.dragStart=function(t,e){this.isDraggable&&(this.dragStartPosition=this.x,this.startAnimation(),i.removeEventListener("scroll",this),this.dispatchEvent("dragStart",t,[e]))},n.pointerMove=function(t,e){var i=this._dragPointerMove(t,e);this.dispatchEvent("pointerMove",t,[e,i]),this._dragMove(t,e,i)},n.dragMove=function(t,e,i){if(this.isDraggable){t.preventDefault(),this.previousDragX=this.dragX;var n=this.options.rightToLeft?-1:1;this.options.wrapAround&&(i.x=i.x%this.slideableWidth);var s=this.dragStartPosition+i.x*n;if(!this.options.wrapAround&&this.slides.length){var o=Math.max(-this.slides[0].target,this.dragStartPosition);s=o<s?.5*(s+o):s;var r=Math.min(-this.getLastSlide().target,this.dragStartPosition);s=s<r?.5*(s+r):s}this.dragX=s,this.dragMoveTime=new Date,this.dispatchEvent("dragMove",t,[e,i])}},n.dragEnd=function(t,e){if(this.isDraggable){this.options.freeScroll&&(this.isFreeScrolling=!0);var i=this.dragEndRestingSelect();if(this.options.freeScroll&&!this.options.wrapAround){var n=this.getRestingPosition();this.isFreeScrolling=-n>this.slides[0].target&&-n<this.getLastSlide().target}else this.options.freeScroll||i!=this.selectedIndex||(i+=this.dragEndBoostSelect());delete this.previousDragX,this.isDragSelect=this.options.wrapAround,this.select(i),delete this.isDragSelect,this.dispatchEvent("dragEnd",t,[e])}},n.dragEndRestingSelect=function(){var t=this.getRestingPosition(),e=Math.abs(this.getSlideDistance(-t,this.selectedIndex)),i=this._getClosestResting(t,e,1),n=this._getClosestResting(t,e,-1);return i.distance<n.distance?i.index:n.index},n._getClosestResting=function(t,e,i){for(var n=this.selectedIndex,s=1/0,o=this.options.contain&&!this.options.wrapAround?function(t,e){return t<=e}:function(t,e){return t<e};o(e,s)&&(n+=i,s=e,null!==(e=this.getSlideDistance(-t,n)));)e=Math.abs(e);return{distance:s,index:n-i}},n.getSlideDistance=function(t,e){var i=this.slides.length,n=this.options.wrapAround&&1<i,s=n?a.modulo(e,i):e,o=this.slides[s];if(!o)return null;var r=n?this.slideableWidth*Math.floor(e/i):0;return t-(o.target+r)},n.dragEndBoostSelect=function(){if(void 0===this.previousDragX||!this.dragMoveTime||100<new Date-this.dragMoveTime)return 0;var t=this.getSlideDistance(-this.dragX,this.selectedIndex),e=this.previousDragX-this.dragX;return 0<t&&0<e?1:t<0&&e<0?-1:0},n.staticClick=function(t,e){var i=this.getParentCell(t.target),n=i&&i.element,s=i&&this.cells.indexOf(i);this.dispatchEvent("staticClick",t,[e,n,s])},n.onscroll=function(){var t=l(),e=this.pointerDownScroll.x-t.x,i=this.pointerDownScroll.y-t.y;(3<Math.abs(e)||3<Math.abs(i))&&this._pointerDone()},t}),function(n,s){"function"==typeof define&&define.amd?define("flickity/js/prev-next-button",["./flickity","unipointer/unipointer","fizzy-ui-utils/utils"],function(t,e,i){return s(n,t,e,i)}):"object"==typeof module&&module.exports?module.exports=s(n,require("./flickity"),require("unipointer"),require("fizzy-ui-utils")):s(n,n.Flickity,n.Unipointer,n.fizzyUIUtils)}(window,function(t,e,i,n){"use strict";var s="http://www.w3.org/2000/svg";function o(t,e){this.direction=t,this.parent=e,this._create()}(o.prototype=Object.create(i.prototype))._create=function(){this.isEnabled=!0,this.isPrevious=-1==this.direction;var t=this.parent.options.rightToLeft?1:-1;this.isLeft=this.direction==t;var e=this.element=document.createElement("button");e.className="flickity-button flickity-prev-next-button",e.className+=this.isPrevious?" previous":" next",e.setAttribute("type","button"),this.disable(),e.setAttribute("aria-label",this.isPrevious?"Previous":"Next");var i=this.createSVG();e.appendChild(i),this.parent.on("select",this.update.bind(this)),this.on("pointerDown",this.parent.childUIPointerDown.bind(this.parent))},o.prototype.activate=function(){this.bindStartEvent(this.element),this.element.addEventListener("click",this),this.parent.element.appendChild(this.element)},o.prototype.deactivate=function(){this.parent.element.removeChild(this.element),this.unbindStartEvent(this.element),this.element.removeEventListener("click",this)},o.prototype.createSVG=function(){var t=document.createElementNS(s,"svg");t.setAttribute("class","flickity-button-icon"),t.setAttribute("viewBox","0 0 100 100");var e=document.createElementNS(s,"path"),i=function(t){return"string"!=typeof t?"M "+t.x0+",50 L "+t.x1+","+(t.y1+50)+" L "+t.x2+","+(t.y2+50)+" L "+t.x3+",50  L "+t.x2+","+(50-t.y2)+" L "+t.x1+","+(50-t.y1)+" Z":t}(this.parent.options.arrowShape);return e.setAttribute("d",i),e.setAttribute("class","arrow"),this.isLeft||e.setAttribute("transform","translate(100, 100) rotate(180) "),t.appendChild(e),t},o.prototype.handleEvent=n.handleEvent,o.prototype.onclick=function(){if(this.isEnabled){this.parent.uiChange();var t=this.isPrevious?"previous":"next";this.parent[t]()}},o.prototype.enable=function(){this.isEnabled||(this.element.disabled=!1,this.isEnabled=!0)},o.prototype.disable=function(){this.isEnabled&&(this.element.disabled=!0,this.isEnabled=!1)},o.prototype.update=function(){var t=this.parent.slides;if(this.parent.options.wrapAround&&1<t.length)this.enable();else{var e=t.length?t.length-1:0,i=this.isPrevious?0:e;this[this.parent.selectedIndex==i?"disable":"enable"]()}},o.prototype.destroy=function(){this.deactivate(),this.allOff()},n.extend(e.defaults,{prevNextButtons:!0,arrowShape:{x0:10,x1:60,y1:50,x2:70,y2:40,x3:30}}),e.createMethods.push("_createPrevNextButtons");var r=e.prototype;return r._createPrevNextButtons=function(){this.options.prevNextButtons&&(this.prevButton=new o(-1,this),this.nextButton=new o(1,this),this.on("activate",this.activatePrevNextButtons))},r.activatePrevNextButtons=function(){this.prevButton.activate(),this.nextButton.activate(),this.on("deactivate",this.deactivatePrevNextButtons)},r.deactivatePrevNextButtons=function(){this.prevButton.deactivate(),this.nextButton.deactivate(),this.off("deactivate",this.deactivatePrevNextButtons)},e.PrevNextButton=o,e}),function(n,s){"function"==typeof define&&define.amd?define("flickity/js/page-dots",["./flickity","unipointer/unipointer","fizzy-ui-utils/utils"],function(t,e,i){return s(n,t,e,i)}):"object"==typeof module&&module.exports?module.exports=s(n,require("./flickity"),require("unipointer"),require("fizzy-ui-utils")):s(n,n.Flickity,n.Unipointer,n.fizzyUIUtils)}(window,function(t,e,i,n){function s(t){this.parent=t,this._create()}(s.prototype=Object.create(i.prototype))._create=function(){this.holder=document.createElement("ol"),this.holder.className="flickity-page-dots",this.dots=[],this.handleClick=this.onClick.bind(this),this.on("pointerDown",this.parent.childUIPointerDown.bind(this.parent))},s.prototype.activate=function(){this.setDots(),this.holder.addEventListener("click",this.handleClick),this.bindStartEvent(this.holder),this.parent.element.appendChild(this.holder)},s.prototype.deactivate=function(){this.holder.removeEventListener("click",this.handleClick),this.unbindStartEvent(this.holder),this.parent.element.removeChild(this.holder)},s.prototype.setDots=function(){var t=this.parent.slides.length-this.dots.length;0<t?this.addDots(t):t<0&&this.removeDots(-t)},s.prototype.addDots=function(t){for(var e=document.createDocumentFragment(),i=[],n=this.dots.length,s=n+t,o=n;o<s;o++){var r=document.createElement("li");r.className="dot",r.setAttribute("aria-label","Page dot "+(o+1)),e.appendChild(r),i.push(r)}this.holder.appendChild(e),this.dots=this.dots.concat(i)},s.prototype.removeDots=function(t){this.dots.splice(this.dots.length-t,t).forEach(function(t){this.holder.removeChild(t)},this)},s.prototype.updateSelected=function(){this.selectedDot&&(this.selectedDot.className="dot",this.selectedDot.removeAttribute("aria-current")),this.dots.length&&(this.selectedDot=this.dots[this.parent.selectedIndex],this.selectedDot.className="dot is-selected",this.selectedDot.setAttribute("aria-current","step"))},s.prototype.onTap=s.prototype.onClick=function(t){var e=t.target;if("LI"==e.nodeName){this.parent.uiChange();var i=this.dots.indexOf(e);this.parent.select(i)}},s.prototype.destroy=function(){this.deactivate(),this.allOff()},e.PageDots=s,n.extend(e.defaults,{pageDots:!0}),e.createMethods.push("_createPageDots");var o=e.prototype;return o._createPageDots=function(){this.options.pageDots&&(this.pageDots=new s(this),this.on("activate",this.activatePageDots),this.on("select",this.updateSelectedPageDots),this.on("cellChange",this.updatePageDots),this.on("resize",this.updatePageDots),this.on("deactivate",this.deactivatePageDots))},o.activatePageDots=function(){this.pageDots.activate()},o.updateSelectedPageDots=function(){this.pageDots.updateSelected()},o.updatePageDots=function(){this.pageDots.setDots()},o.deactivatePageDots=function(){this.pageDots.deactivate()},e.PageDots=s,e}),function(t,n){"function"==typeof define&&define.amd?define("flickity/js/player",["ev-emitter/ev-emitter","fizzy-ui-utils/utils","./flickity"],function(t,e,i){return n(t,e,i)}):"object"==typeof module&&module.exports?module.exports=n(require("ev-emitter"),require("fizzy-ui-utils"),require("./flickity")):n(t.EvEmitter,t.fizzyUIUtils,t.Flickity)}(window,function(t,e,i){function n(t){this.parent=t,this.state="stopped",this.onVisibilityChange=this.visibilityChange.bind(this),this.onVisibilityPlay=this.visibilityPlay.bind(this)}(n.prototype=Object.create(t.prototype)).play=function(){"playing"!=this.state&&(document.hidden?document.addEventListener("visibilitychange",this.onVisibilityPlay):(this.state="playing",document.addEventListener("visibilitychange",this.onVisibilityChange),this.tick()))},n.prototype.tick=function(){if("playing"==this.state){var t=this.parent.options.autoPlay;t="number"==typeof t?t:3e3;var e=this;this.clear(),this.timeout=setTimeout(function(){e.parent.next(!0),e.tick()},t)}},n.prototype.stop=function(){this.state="stopped",this.clear(),document.removeEventListener("visibilitychange",this.onVisibilityChange)},n.prototype.clear=function(){clearTimeout(this.timeout)},n.prototype.pause=function(){"playing"==this.state&&(this.state="paused",this.clear())},n.prototype.unpause=function(){"paused"==this.state&&this.play()},n.prototype.visibilityChange=function(){this[document.hidden?"pause":"unpause"]()},n.prototype.visibilityPlay=function(){this.play(),document.removeEventListener("visibilitychange",this.onVisibilityPlay)},e.extend(i.defaults,{pauseAutoPlayOnHover:!0}),i.createMethods.push("_createPlayer");var s=i.prototype;return s._createPlayer=function(){this.player=new n(this),this.on("activate",this.activatePlayer),this.on("uiChange",this.stopPlayer),this.on("pointerDown",this.stopPlayer),this.on("deactivate",this.deactivatePlayer)},s.activatePlayer=function(){this.options.autoPlay&&(this.player.play(),this.element.addEventListener("mouseenter",this))},s.playPlayer=function(){this.player.play()},s.stopPlayer=function(){this.player.stop()},s.pausePlayer=function(){this.player.pause()},s.unpausePlayer=function(){this.player.unpause()},s.deactivatePlayer=function(){this.player.stop(),this.element.removeEventListener("mouseenter",this)},s.onmouseenter=function(){this.options.pauseAutoPlayOnHover&&(this.player.pause(),this.element.addEventListener("mouseleave",this))},s.onmouseleave=function(){this.player.unpause(),this.element.removeEventListener("mouseleave",this)},i.Player=n,i}),function(i,n){"function"==typeof define&&define.amd?define("flickity/js/add-remove-cell",["./flickity","fizzy-ui-utils/utils"],function(t,e){return n(i,t,e)}):"object"==typeof module&&module.exports?module.exports=n(i,require("./flickity"),require("fizzy-ui-utils")):n(i,i.Flickity,i.fizzyUIUtils)}(window,function(t,e,n){var i=e.prototype;return i.insert=function(t,e){var i=this._makeCells(t);if(i&&i.length){var n=this.cells.length;e=void 0===e?n:e;var s=function(t){var e=document.createDocumentFragment();return t.forEach(function(t){e.appendChild(t.element)}),e}(i),o=e==n;if(o)this.slider.appendChild(s);else{var r=this.cells[e].element;this.slider.insertBefore(s,r)}if(0===e)this.cells=i.concat(this.cells);else if(o)this.cells=this.cells.concat(i);else{var a=this.cells.splice(e,n-e);this.cells=this.cells.concat(i).concat(a)}this._sizeCells(i),this.cellChange(e,!0)}},i.append=function(t){this.insert(t,this.cells.length)},i.prepend=function(t){this.insert(t,0)},i.remove=function(t){var e=this.getCells(t);if(e&&e.length){var i=this.cells.length-1;e.forEach(function(t){t.remove();var e=this.cells.indexOf(t);i=Math.min(e,i),n.removeFrom(this.cells,t)},this),this.cellChange(i,!0)}},i.cellSizeChange=function(t){var e=this.getCell(t);if(e){e.getSize();var i=this.cells.indexOf(e);this.cellChange(i)}},i.cellChange=function(t,e){var i=this.selectedElement;this._positionCells(t),this._getWrapShiftCells(),this.setGallerySize();var n=this.getCell(i);n&&(this.selectedIndex=this.getCellSlideIndex(n)),this.selectedIndex=Math.min(this.slides.length-1,this.selectedIndex),this.emitEvent("cellChange",[t]),this.select(this.selectedIndex),e&&this.positionSliderAtSelected()},e}),function(i,n){"function"==typeof define&&define.amd?define("flickity/js/lazyload",["./flickity","fizzy-ui-utils/utils"],function(t,e){return n(i,t,e)}):"object"==typeof module&&module.exports?module.exports=n(i,require("./flickity"),require("fizzy-ui-utils")):n(i,i.Flickity,i.fizzyUIUtils)}(window,function(t,e,o){"use strict";e.createMethods.push("_createLazyload");var i=e.prototype;function s(t,e){this.img=t,this.flickity=e,this.load()}return i._createLazyload=function(){this.on("select",this.lazyLoad)},i.lazyLoad=function(){var t=this.options.lazyLoad;if(t){var e="number"==typeof t?t:0,i=this.getAdjacentCellElements(e),n=[];i.forEach(function(t){var e=function(t){if("IMG"==t.nodeName){var e=t.getAttribute("data-flickity-lazyload"),i=t.getAttribute("data-flickity-lazyload-src"),n=t.getAttribute("data-flickity-lazyload-srcset");if(e||i||n)return[t]}var s=t.querySelectorAll("img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]");return o.makeArray(s)}(t);n=n.concat(e)}),n.forEach(function(t){new s(t,this)},this)}},s.prototype.handleEvent=o.handleEvent,s.prototype.load=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this);var t=this.img.getAttribute("data-flickity-lazyload")||this.img.getAttribute("data-flickity-lazyload-src"),e=this.img.getAttribute("data-flickity-lazyload-srcset");this.img.src=t,e&&this.img.setAttribute("srcset",e),this.img.removeAttribute("data-flickity-lazyload"),this.img.removeAttribute("data-flickity-lazyload-src"),this.img.removeAttribute("data-flickity-lazyload-srcset")},s.prototype.onload=function(t){this.complete(t,"flickity-lazyloaded")},s.prototype.onerror=function(t){this.complete(t,"flickity-lazyerror")},s.prototype.complete=function(t,e){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this);var i=this.flickity.getParentCell(this.img),n=i&&i.element;this.flickity.cellSizeChange(n),this.img.classList.add(e),this.flickity.dispatchEvent("lazyLoad",t,n)},e.LazyLoader=s,e}),function(t,e){"function"==typeof define&&define.amd?define("flickity/js/index",["./flickity","./drag","./prev-next-button","./page-dots","./player","./add-remove-cell","./lazyload"],e):"object"==typeof module&&module.exports&&(module.exports=e(require("./flickity"),require("./drag"),require("./prev-next-button"),require("./page-dots"),require("./player"),require("./add-remove-cell"),require("./lazyload")))}(window,function(t){return t}),function(t,e){"function"==typeof define&&define.amd?define("flickity-as-nav-for/as-nav-for",["flickity/js/index","fizzy-ui-utils/utils"],e):"object"==typeof module&&module.exports?module.exports=e(require("flickity"),require("fizzy-ui-utils")):t.Flickity=e(t.Flickity,t.fizzyUIUtils)}(window,function(n,s){n.createMethods.push("_createAsNavFor");var t=n.prototype;return t._createAsNavFor=function(){this.on("activate",this.activateAsNavFor),this.on("deactivate",this.deactivateAsNavFor),this.on("destroy",this.destroyAsNavFor);var t=this.options.asNavFor;if(t){var e=this;setTimeout(function(){e.setNavCompanion(t)})}},t.setNavCompanion=function(t){t=s.getQueryElement(t);var e=n.data(t);if(e&&e!=this){this.navCompanion=e;var i=this;this.onNavCompanionSelect=function(){i.navCompanionSelect()},e.on("select",this.onNavCompanionSelect),this.on("staticClick",this.onNavStaticClick),this.navCompanionSelect(!0)}},t.navCompanionSelect=function(t){var e=this.navCompanion&&this.navCompanion.selectedCells;if(e){var i=e[0],n=this.navCompanion.cells.indexOf(i),s=n+e.length-1,o=Math.floor(function(t,e,i){return(e-t)*i+t}(n,s,this.navCompanion.cellAlign));if(this.selectCell(o,!1,t),this.removeNavSelectedElements(),!(o>=this.cells.length)){var r=this.cells.slice(n,1+s);this.navSelectedElements=r.map(function(t){return t.element}),this.changeNavSelectedClass("add")}}},t.changeNavSelectedClass=function(e){this.navSelectedElements.forEach(function(t){t.classList[e]("is-nav-selected")})},t.activateAsNavFor=function(){this.navCompanionSelect(!0)},t.removeNavSelectedElements=function(){this.navSelectedElements&&(this.changeNavSelectedClass("remove"),delete this.navSelectedElements)},t.onNavStaticClick=function(t,e,i,n){"number"==typeof n&&this.navCompanion.selectCell(n)},t.deactivateAsNavFor=function(){this.removeNavSelectedElements()},t.destroyAsNavFor=function(){this.navCompanion&&(this.navCompanion.off("select",this.onNavCompanionSelect),this.off("staticClick",this.onNavStaticClick),delete this.navCompanion)},n}),function(e,i){"use strict";"function"==typeof define&&define.amd?define("imagesloaded/imagesloaded",["ev-emitter/ev-emitter"],function(t){return i(e,t)}):"object"==typeof module&&module.exports?module.exports=i(e,require("ev-emitter")):e.imagesLoaded=i(e,e.EvEmitter)}("undefined"!=typeof window?window:this,function(e,t){var s=e.jQuery,o=e.console;function r(t,e){for(var i in e)t[i]=e[i];return t}var a=Array.prototype.slice;function l(t,e,i){if(!(this instanceof l))return new l(t,e,i);var n=t;"string"==typeof t&&(n=document.querySelectorAll(t)),n?(this.elements=function(t){return Array.isArray(t)?t:"object"==typeof t&&"number"==typeof t.length?a.call(t):[t]}(n),this.options=r({},this.options),"function"==typeof e?i=e:r(this.options,e),i&&this.on("always",i),this.getImages(),s&&(this.jqDeferred=new s.Deferred),setTimeout(this.check.bind(this))):o.error("Bad element for imagesLoaded "+(n||t))}(l.prototype=Object.create(t.prototype)).options={},l.prototype.getImages=function(){this.images=[],this.elements.forEach(this.addElementImages,this)},l.prototype.addElementImages=function(t){"IMG"==t.nodeName&&this.addImage(t),!0===this.options.background&&this.addElementBackgroundImages(t);var e=t.nodeType;if(e&&h[e]){for(var i=t.querySelectorAll("img"),n=0;n<i.length;n++){var s=i[n];this.addImage(s)}if("string"==typeof this.options.background){var o=t.querySelectorAll(this.options.background);for(n=0;n<o.length;n++){var r=o[n];this.addElementBackgroundImages(r)}}}};var h={1:!0,9:!0,11:!0};function i(t){this.img=t}function n(t,e){this.url=t,this.element=e,this.img=new Image}return l.prototype.addElementBackgroundImages=function(t){var e=getComputedStyle(t);if(e)for(var i=/url\((['"])?(.*?)\1\)/gi,n=i.exec(e.backgroundImage);null!==n;){var s=n&&n[2];s&&this.addBackground(s,t),n=i.exec(e.backgroundImage)}},l.prototype.addImage=function(t){var e=new i(t);this.images.push(e)},l.prototype.addBackground=function(t,e){var i=new n(t,e);this.images.push(i)},l.prototype.check=function(){var n=this;function e(t,e,i){setTimeout(function(){n.progress(t,e,i)})}this.progressedCount=0,this.hasAnyBroken=!1,this.images.length?this.images.forEach(function(t){t.once("progress",e),t.check()}):this.complete()},l.prototype.progress=function(t,e,i){this.progressedCount++,this.hasAnyBroken=this.hasAnyBroken||!t.isLoaded,this.emitEvent("progress",[this,t,e]),this.jqDeferred&&this.jqDeferred.notify&&this.jqDeferred.notify(this,t),this.progressedCount==this.images.length&&this.complete(),this.options.debug&&o&&o.log("progress: "+i,t,e)},l.prototype.complete=function(){var t=this.hasAnyBroken?"fail":"done";if(this.isComplete=!0,this.emitEvent(t,[this]),this.emitEvent("always",[this]),this.jqDeferred){var e=this.hasAnyBroken?"reject":"resolve";this.jqDeferred[e](this)}},(i.prototype=Object.create(t.prototype)).check=function(){this.getIsImageComplete()?this.confirm(0!==this.img.naturalWidth,"naturalWidth"):(this.proxyImage=new Image,this.proxyImage.addEventListener("load",this),this.proxyImage.addEventListener("error",this),this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.proxyImage.src=this.img.src)},i.prototype.getIsImageComplete=function(){return this.img.complete&&this.img.naturalWidth},i.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.img,e])},i.prototype.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},i.prototype.onload=function(){this.confirm(!0,"onload"),this.unbindEvents()},i.prototype.onerror=function(){this.confirm(!1,"onerror"),this.unbindEvents()},i.prototype.unbindEvents=function(){this.proxyImage.removeEventListener("load",this),this.proxyImage.removeEventListener("error",this),this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},(n.prototype=Object.create(i.prototype)).check=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.img.src=this.url,this.getIsImageComplete()&&(this.confirm(0!==this.img.naturalWidth,"naturalWidth"),this.unbindEvents())},n.prototype.unbindEvents=function(){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},n.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.element,e])},l.makeJQueryPlugin=function(t){(t=t||e.jQuery)&&((s=t).fn.imagesLoaded=function(t,e){return new l(this,t,e).jqDeferred.promise(s(this))})},l.makeJQueryPlugin(),l}),function(i,n){"function"==typeof define&&define.amd?define(["flickity/js/index","imagesloaded/imagesloaded"],function(t,e){return n(i,t,e)}):"object"==typeof module&&module.exports?module.exports=n(i,require("flickity"),require("imagesloaded")):i.Flickity=n(i,i.Flickity,i.imagesLoaded)}(window,function(t,e,i){"use strict";e.createMethods.push("_createImagesLoaded");var n=e.prototype;return n._createImagesLoaded=function(){this.on("activate",this.imagesLoaded)},n.imagesLoaded=function(){if(this.options.imagesLoaded){var n=this;i(this.slider).on("progress",function(t,e){var i=n.getParentCell(e.img);n.cellSizeChange(i&&i.element),n.options.freeScroll||n.positionSliderAtSelected()})}},e});

;("use strict")

var unitPriceSeparator = "/"

Sunrise.Sections = function Sections() {
  this.constructors = {}
  this.instances = []
  document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this))
  document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this))
  document.addEventListener("shopify:section:select", this._onSelect.bind(this))
  document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this))
  document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this))
  document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this))
}

Sunrise.Sections.prototype = Object.assign({}, Sunrise.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute("data-section-id")
    var type = container.getAttribute("data-section-type")

    constructor = constructor || this.constructors[type]

    if (typeof constructor === "undefined") {
      return
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container,
    })

    this.instances.push(instance)
  },

  _onSectionLoad: function (evt) {
    var container = document.querySelector('[data-section-id="' + evt.detail.sectionId + '"]')

    if (container) {
      this._createInstance(container)
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId

      if (isEventInstance) {
        if (typeof instance.onUnload === "function") {
          instance.onUnload(evt)
        }
      }

      return !isEventInstance
    })
  },

  _onSelect: function (evt) {
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId
    })

    if (typeof instance !== "undefined" && typeof instance.onSelect === "function") {
      instance.onSelect(evt)
    }
  },

  _onDeselect: function (evt) {
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId
    })

    if (typeof instance !== "undefined" && typeof instance.onDeselect === "function") {
      instance.onDeselect(evt)
    }
  },

  _onBlockSelect: function (evt) {
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId
    })

    if (typeof instance !== "undefined" && typeof instance.onBlockSelect === "function") {
      instance.onBlockSelect(evt)
    }
  },

  _onBlockDeselect: function (evt) {
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId
    })

    if (typeof instance !== "undefined" && typeof instance.onBlockDeselect === "function") {
      instance.onBlockDeselect(evt)
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function (container) {
        this._createInstance(container, constructor)
      }.bind(this)
    )
  },
})

Sunrise.customerTemplates = (function () {
  function initEventListeners() {
    var resetPasswordLink = document.querySelector("#recover-password")
    var showLoginForm = document.querySelector("#hide-password-form")

    if (resetPasswordLink) {
      resetPasswordLink.addEventListener(
        "click",
        function (e) {
          e.preventDefault()
          toggleRecoverPasswordForm()
        }.bind(this)
      )
    }

    if (showLoginForm) {
      showLoginForm.addEventListener(
        "click",
        function (e) {
          e.preventDefault()
          toggleRecoverPasswordForm()
        }.bind(this)
      )
    }
  }

  //Show/Hide recover password form
  function toggleRecoverPasswordForm() {
    document.querySelector("#recover-password-form").classList.toggle("hide")
    document.querySelector("#customer-login-form").classList.toggle("hide")
  }

  // Show reset password success message
  function resetPasswordSuccess() {
    var formState = document.querySelector(".reset-password-success")

    // check if reset password form was successfully submited.
    if (!formState) {
      return
    }

    // show success message
    var resetSuccess = document.getElementById("reset-success")
    resetSuccess.classList.remove("hide")
    resetSuccess.focus()
  }

  // Show/hide customer address forms
  function customerAddressForm() {
    var newAddressForm = document.getElementById("AddressNewForm")
    var newAddressFormButton = document.getElementById("AddressNewButton")

    if (!newAddressForm) {
      return
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
        hideElement: "AddressProvinceContainerNew",
      })
    }

    // Initialize each edit form's country/province selector
    document.querySelectorAll(".address-country-option").forEach(function (option) {
      var formId = option.dataset.formId
      var countrySelector = "AddressCountry_" + formId
      var provinceSelector = "AddressProvince_" + formId
      var containerSelector = "AddressProvinceContainer_" + formId
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector,
      })
    })

    // Toggle new/edit address forms
    document.querySelectorAll(".address-new-toggle").forEach(function (button) {
      button.addEventListener("click", function () {
        var isExpanded = newAddressFormButton.getAttribute("aria-expanded") === "true"

        newAddressForm.classList.toggle("hide")
        newAddressFormButton.setAttribute("aria-expanded", !isExpanded)
        newAddressFormButton.focus()
      })
    })

    document.querySelectorAll(".address-edit-toggle").forEach(function (button) {
      button.addEventListener("click", function (evt) {
        var formId = evt.target.dataset.formId
        var editButton = document.getElementById("EditFormButton_" + formId)
        var editAddress = document.getElementById("EditAddress_" + formId)
        var isExpanded = editButton.getAttribute("aria-expanded") === "true"

        editAddress.classList.toggle("hide")
        editButton.setAttribute("aria-expanded", !isExpanded)
        editButton.focus()
      })
    })

    document.querySelectorAll(".address-delete").forEach(function (button) {
      button.addEventListener("click", function (evt) {
        var target = evt.target.dataset.target
        var confirmMessage = evt.target.dataset.confirmMessage

        if (confirm(confirmMessage || "Are you sure you wish to delete this address?")) {
          Shopify.postLink(target, {
            parameters: { _method: "delete" },
          })
        }
      })
    })
  }

  // Check URL for reset password hash
  function checkUrlHash() {
    var hash = window.location.hash

    // Allow deep linking to recover password form
    if (hash === "#recover") {
      toggleRecoverPasswordForm()
    }
  }

  return {
    init: function () {
      initEventListeners()
      checkUrlHash()
      resetPasswordSuccess()
      customerAddressForm()
    },
  }
})()

//Image Helper Functions
Sunrise.Images = (function () {
  /* Preloads an image in memory and uses the browsers cache to store it until needed.
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute */
  function preload(images, size) {
    if (typeof images === "string") {
      images = [images]
    }
    for (var i = 0; i < images.length; i++) {
      var image = images[i]
      this.loadImage(this.getSizedImageUrl(image, size))
    }
  }

  /* Loads and caches an image in the browsers cache.
   * @param {string} path - An image url */
  function loadImage(path) {
    new Image().src = path
  }

  /* Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src)
    var imageUrl = this.getSizedImageUrl(image.src, size)

    if (callback) {
      callback(imageUrl, image, element)
    } else {
      element.src = imageUrl
    }
  }

  /* Find the Shopify image attribute size
   * @param {string} src
   * @returns {null} */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/)

    if (match !== null) {
      return match[1]
    } else {
      return null
    }
  }

  /* Adds a Shopify size attribute to a URL
   * @param src
   * @param size
   * @returns {*} */
  function getSizedImageUrl(src, size) {
    if (size == null) {
      return src
    }

    if (size === "master") {
      return this.removeProtocol(src)
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i)

    if (match != null) {
      var prefix = src.split(match[0])
      var suffix = match[0]

      return this.removeProtocol(prefix[0] + "_" + size + suffix)
    }

    return null
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "")
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
  }
})()

Sunrise.rte = {
  /*
   * Wrap tables in a container div to make them scrollable when needed
   * @param {object} options - Options to be used
   * @param {NodeList} options.tables - Elements of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function (options) {
    options.tables.forEach(function (table) {
      var wrapper = document.createElement("div")
      wrapper.classList.add(options.tableWrapperClass)

      table.parentNode.insertBefore(wrapper, table)
      wrapper.appendChild(table)
    })
  },

  /*
   * Wrap iframes in a container div to make them responsive
   * @param {object} options - Options to be used
   * @param {NodeList} options.iframes - Elements of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function (options) {
    options.iframes.forEach(function (iframe) {
      var wrapper = document.createElement("div")
      wrapper.classList.add(options.iframeWrapperClass)

      iframe.parentNode.insertBefore(wrapper, iframe)
      wrapper.appendChild(iframe)

      iframe.src = iframe.src
    })
  },
}

Sunrise.Helpers = (function () {
  var touchDevice = false

  function setTouch() {
    touchDevice = true
  }

  function isTouch() {
    return touchDevice
  }

  function promiseStylesheet(stylesheet) {
    var stylesheetUrl = stylesheet || window.theme.stylesheet
    if (typeof this.stylesheetPromise === "undefined") {
      this.stylesheetPromise = new Promise(function (resolve) {
        var link = document.querySelector('link[href="' + stylesheetUrl + '"]')

        if (link.loaded) resolve()

        link.addEventListener("load", function () {
          setTimeout(resolve, 0)
        })
      })
    }
    return this.stylesheetPromise
  }

  function debounce(func, wait, immediate) {
    var timeout

    return function () {
      var context = this,
        args = arguments

      var later = function () {
        timeout = null
        if (!immediate) func.apply(context, args)
      }

      var callNow = immediate && !timeout
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
      if (callNow) func.apply(context, args)
    }
  }

  function trapFocus(selector) {
    var el = document.querySelector(selector)
    var focusableEls = el.querySelectorAll(
        'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
      ),
      firstFocusableEl = focusableEls[0],
      lastFocusableEl = focusableEls[focusableEls.length - 1],
      KEYCODE_TAB = 9

    el.addEventListener("keydown", function (e) {
      var isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB
      if (!isTabPressed) {
        return
      }
      if (e.shiftKey) {
        //shift + tab
        if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus()
          e.preventDefault()
        }
      } else {
        //tab
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus()
          e.preventDefault()
        }
      }
    })
  }

  function triggerEvent(el, type) {
    var e = document.createEvent("HTMLEvents")
    e.initEvent(type, false, true)
    el.dispatchEvent(e)
  }

  function slideUp(target, duration) {
    target.style.transitionProperty = "height, margin, padding"
    target.style.transitionDuration = duration + "ms"
    target.style.boxSizing = "border-box"
    target.style.height = target.offsetHeight + "px"
    target.style.overflow = "hidden"
    target.style.height = 0
    target.style.paddingTop = 0
    target.style.paddingBottom = 0
    target.style.marginTop = 0
    target.style.marginBottom = 0
    window.setTimeout(function () {
      target.style.display = "none"
      target.style.removeProperty("height")
      target.style.removeProperty("padding-top")
      target.style.removeProperty("padding-bottom")
      target.style.removeProperty("margin-top")
      target.style.removeProperty("margin-bottom")
      target.style.removeProperty("overflow")
      target.style.removeProperty("transition-duration")
      target.style.removeProperty("transition-property")
    }, duration)
  }

  function slideDown(target, duration) {
    target.style.removeProperty("display")
    var display = window.getComputedStyle(target).display
    if (display === "none") display = "block"
    target.style.display = display
    var height = target.offsetHeight
    target.style.overflow = "hidden"
    target.style.height = 0
    target.style.paddingTop = 0
    target.style.paddingBottom = 0
    target.style.marginTop = 0
    target.style.marginBottom = 0
    target.style.boxSizing = "border-box"
    target.style.transitionProperty = "height, margin, padding"
    target.style.transitionDuration = duration + "ms"
    target.style.height = height + "px"
    target.style.removeProperty("padding-top")
    target.style.removeProperty("padding-bottom")
    target.style.removeProperty("margin-top")
    target.style.removeProperty("margin-bottom")
    window.setTimeout(function () {
      target.style.removeProperty("height")
      target.style.removeProperty("overflow")
      target.style.removeProperty("transition-duration")
      target.style.removeProperty("transition-property")
    }, duration)
  }

  function slideToggle(target, duration) {
    if (window.getComputedStyle(target).display === "none") {
      return slideDown(target, duration)
    } else {
      return slideUp(target, duration)
    }
  }

  function enableScrollLock() {
    scrollPosition = window.pageYOffset
    document.body.style.top = "-" + scrollPosition + "px"
    document.body.classList.add(classes.preventScrolling)
  }

  function disableScrollLock() {
    document.body.classList.remove(classes.preventScrolling)
    document.body.style.removeProperty("top")
    window.scrollTo(0, scrollPosition)
  }

  /* Based on the prepareTransition by Jonathan Snook */
  /* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
  function prepareTransition(element) {
    element.addEventListener(
      "transitionend",
      function (event) {
        event.currentTarget.classList.remove("is-transitioning")
      },
      { once: true }
    )

    var properties = [
      "transition-duration",
      "-moz-transition-duration",
      "-webkit-transition-duration",
      "-o-transition-duration",
    ]

    var duration = 0

    properties.forEach(function (property) {
      var computedValue = getComputedStyle(element)[property]

      if (computedValue) {
        computedValue.replace(/\D/g, "")
        duration || (duration = parseFloat(computedValue))
      }
    })

    if (duration !== 0) {
      element.classList.add("is-transitioning")
    }
  }

  function getScript(source, beforeEl) {
    return new Promise(function (resolve, reject) {
      var script = document.createElement("script")
      var prior = beforeEl || document.getElementsByTagName("script")[0]

      script.async = true
      script.defer = true

      function onloadHander(_, isAbort) {
        if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
          script.onload = null
          script.onreadystatechange = null
          script = undefined

          if (isAbort) {
            reject()
          } else {
            resolve()
          }
        }
      }

      script.onload = onloadHander
      script.onreadystatechange = onloadHander

      script.src = source
      prior.parentNode.insertBefore(script, prior)
    })
  }

  return {
    setTouch: setTouch,
    isTouch: isTouch,
    promiseStylesheet: promiseStylesheet,
    triggerEvent: triggerEvent,
    debounce: debounce,
    slideUp: slideUp,
    slideDown: slideDown,
    slideToggle: slideToggle,
    enableScrollLock: enableScrollLock,
    disableScrollLock: disableScrollLock,
    prepareTransition: prepareTransition,
    trapFocus: trapFocus,
    getScript: getScript,
  }
})()

Sunrise.LibraryLoader = (function () {
  var types = {
    link: "link",
    script: "script",
  }

  var status = {
    requested: "requested",
    loaded: "loaded",
  }

  var cloudCdn = "https://cdn.shopify.com/shopifycloud/"

  var libraries = {
    youtubeSdk: {
      tagId: "youtube-sdk",
      src: "https://www.youtube.com/iframe_api",
      type: types.script,
    },
    plyrShopifyStyles: {
      tagId: "plyr-shopify-styles",
      src: cloudCdn + "shopify-plyr/v1.0/shopify-plyr.css",
      type: types.link,
    },
    modelViewerUiStyles: {
      tagId: "shopify-model-viewer-ui-styles",
      src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
      type: types.link,
    },
  }

  function load(libraryName, callback) {
    var library = libraries[libraryName]

    if (!library) return
    if (library.status === status.requested) return

    callback = callback || function () {}
    if (library.status === status.loaded) {
      callback()
      return
    }

    library.status = status.requested

    var tag

    switch (library.type) {
      case types.script:
        tag = createScriptTag(library, callback)
        break
      case types.link:
        tag = createLinkTag(library, callback)
        break
    }

    tag.id = library.tagId
    library.element = tag

    var firstScriptTag = document.getElementsByTagName(library.type)[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
  }

  function createScriptTag(library, callback) {
    var tag = document.createElement("script")
    tag.src = library.src
    tag.addEventListener("load", function () {
      library.status = status.loaded
      callback()
    })
    return tag
  }

  function createLinkTag(library, callback) {
    var tag = document.createElement("link")
    tag.href = library.src
    tag.rel = "stylesheet"
    tag.type = "text/css"
    tag.addEventListener("load", function () {
      library.status = status.loaded
      callback()
    })
    return tag
  }

  return {
    load: load,
  }
})()

Sunrise.Video = (function () {
  var autoplayCheckComplete = false
  var playOnClickChecked = false
  var playOnClick = false
  var youtubeLoaded = false
  var videos = {}
  var videoPlayers = []
  var videoOptions = {
    ratio: 16 / 9,
    scrollAnimationDuration: 400,
    playerVars: {
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      wmode: "opaque",
      branding: 0,
      autohide: 0,
      rel: 0,
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange,
    },
  }
  var classes = {
    playing: "video-is-playing",
    paused: "video-is-paused",
    loading: "video-is-loading",
    loaded: "video-is-loaded",
    backgroundVideoWrapper: "video-background-wrapper",
    videoWithImage: "video--image_with_play",
    backgroundVideo: "video--background",
    userPaused: "is-paused",
    supportsAutoplay: "autoplay",
    supportsNoAutoplay: "no-autoplay",
    wrapperMinHeight: "video-section-wrapper--min-height",
  }

  var selectors = {
    section: ".video-section",
    videoWrapper: ".video-section-wrapper",
    playVideoBtn: ".video-control__play",
    closeVideoBtn: ".video-control__close-wrapper",
    pauseVideoBtn: ".video__pause",
    pauseVideoStop: ".video__pause-stop",
    pauseVideoResume: ".video__pause-resume",
    fallbackText: ".icon__fallback-text",
  }

  /**
   * Public functions
   */
  function init(video) {
    if (!video) return

    videos[video.id] = {
      id: video.id,
      videoId: video.dataset.id,
      type: video.dataset.type,
      status: video.dataset.type === "image_with_play" ? "closed" : "background", // closed, open, background
      video: video,
      videoWrapper: video.closest(selectors.videoWrapper),
      section: video.closest(selectors.section),
      controls: video.dataset.type === "background" ? 0 : 1,
    }

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement("script")
      tag.src = "https://www.youtube.com/iframe_api"
      var firstScriptTag = document.getElementsByTagName("script")[0]
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
    }

    playOnClickCheck()
  }

  function customPlayVideo(playerId) {
    // Make sure we have carried out the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === "function") {
      privatePlayVideo(playerId)
    }
  }

  function pauseVideo(playerId) {
    if (videoPlayers[playerId] && typeof videoPlayers[playerId].pauseVideo === "function") {
      videoPlayers[playerId].pauseVideo()
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        createPlayer(key)
      }
    }

    initEvents()
    youtubeLoaded = true
  }

  function editorLoadVideo(key) {
    if (!youtubeLoaded) {
      return
    }
    createPlayer(key)

    initEvents()
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id]
    var player = videoPlayers[id]
    var videoWrapper = videoData.videoWrapper

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData)
    } else if (clicked || autoplayCheckComplete) {
      // Play if autoplay is available or clicked to play
      videoWrapper.classList.remove(classes.loading)
      setAsPlaying(videoData)
      player.playVideo()
      return
    } else {
      player.playVideo()
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported ? classes.supportsAutoplay : classes.supportsNoAutoplay
    document.documentElement.classList.remove(classes.supportsAutoplay, classes.supportsNoAutoplay)
    document.documentElement.classList.add(supportClass)

    if (!supported) {
      playOnClick = true
    }

    autoplayCheckComplete = true
  }

  function playOnClickCheck() {
    if (playOnClickChecked) {
      return
    }

    if (isMobile()) {
      playOnClick = true
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false)
    }

    playOnClickChecked = true
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality("hd1080")
    var videoData = getVideoOptions(evt)
    var videoTitle = evt.target.getVideoData().title
    playOnClickCheck()

    // Prevent tabbing through YouTube player controls until visible
    document.getElementById(videoData.id).setAttribute("tabindex", "-1")

    sizeBackgroundVideos()
    setButtonLabels(videoData.videoWrapper, videoTitle)

    // Customize based on options from the video ID
    if (videoData.type === "background") {
      evt.target.mute()
      privatePlayVideo(videoData.id)
    }

    videoData.videoWrapper.classList.add(classes.loaded)
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt)
    if (
      videoData.status === "background" &&
      !isMobile() &&
      !autoplayCheckComplete &&
      (evt.data === YT.PlayerState.PLAYING || evt.data === YT.PlayerState.BUFFERING)
    ) {
      setAutoplaySupport(true)
      autoplayCheckComplete = true
      videoData.videoWrapper.classList.remove(classes.loading)
    }
    switch (evt.data) {
      case YT.PlayerState.ENDED:
        setAsFinished(videoData)
        break
      case YT.PlayerState.PAUSED:
        // Seeking on a YouTube video also fires a PAUSED state change,
        // checking the state after a delay prevents us pausing the video when
        // the user is seeking instead of pausing
        setTimeout(function () {
          if (evt.target.getPlayerState() === YT.PlayerState.PAUSED) {
            setAsPaused(videoData)
          }
        }, 200)
        break
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case "background":
        videoPlayers[videoData.id].seekTo(0)
        break
      case "image_with_play":
        closeVideo(videoData.id)
        toggleExpandVideo(videoData.id, false)
        break
    }
  }

  function setAsPlaying(videoData) {
    var videoWrapper = videoData.videoWrapper
    var pauseButton = videoWrapper.querySelector(selectors.pauseVideoBtn)

    videoWrapper.classList.remove(classes.loading)

    if (pauseButton.classList.contains(classes.userPaused)) {
      pauseButton.classList.remove(classes.userPaused)
    }

    // Do not change element visibility if it is a background video
    if (videoData.status === "background") {
      return
    }

    document.getElementById(videoData.id).setAttribute("tabindex", "0")

    if (videoData.type === "image_with_play") {
      videoWrapper.classList.remove(classes.paused)
      videoWrapper.classList.add(classes.playing)
    }

    // Update focus to the close button so we stay within the video wrapper,
    // allowing time for the scroll animation
    setTimeout(function () {
      videoWrapper.querySelector(selectors.closeVideoBtn).focus()
    }, videoOptions.scrollAnimationDuration)
  }

  function setAsPaused(videoData) {
    var videoWrapper = videoData.videoWrapper

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.type === "image_with_play") {
      if (videoData.status === "closed") {
        videoWrapper.classList.remove(classes.paused)
      } else {
        videoWrapper.classList.add(classes.paused)
      }
    }

    videoWrapper.classList.remove(classes.playing)
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId]
    var videoWrapper = videoData.videoWrapper

    document.getElementById(videoData.id).setAttribute("tabindex", "-1")

    videoData.status = "closed"

    switch (videoData.type) {
      case "image_with_play":
        videoPlayers[playerId].stopVideo()
        setAsPaused(videoData) // in case the video is already paused
        break
      case "background":
        videoPlayers[playerId].mute()
        setBackgroundVideo(playerId)
        break
    }

    videoWrapper.classList.remove(classes.paused, classes.playing)
  }

  function getVideoOptions(evt) {
    var id = evt.target.getIframe().id
    return videos[id]
  }

  function toggleExpandVideo(playerId, expand) {
    var video = videos[playerId]
    var elementTop = video.videoWrapper.getBoundingClientRect().top + window.pageYOffset
    var playButton = video.videoWrapper.querySelector(selectors.playVideoBtn)
    var offset = 0
    var newHeight = 0

    if (isMobile()) {
      video.videoWrapper.parentElement.classList.toggle("page-width", !expand)
    }

    if (expand) {
      if (isMobile()) {
        newHeight = window.innerWidth / videoOptions.ratio
      } else {
        newHeight = video.videoWrapper.offsetWidth / videoOptions.ratio
      }
      offset = (window.innerHeight - newHeight) / 2

      video.videoWrapper.style.height = video.videoWrapper.getBoundingClientRect().height + "px"
      video.videoWrapper.classList.remove(classes.wrapperMinHeight)
      video.videoWrapper.style.height = newHeight + "px"

      // Animate doesn't work in mobile editor, so we don't use it
      if (!(isMobile() && Shopify.designMode)) {
        var scrollBehavior = document.documentElement.style.scrollBehavior
        document.documentElement.style.scrollBehavior = "smooth"
        window.scrollTo({ top: elementTop - offset })
        document.documentElement.style.scrollBehavior = scrollBehavior
      }
    } else {
      if (isMobile()) {
        newHeight = video.videoWrapper.dataset.mobileHeight
      } else {
        newHeight = video.videoWrapper.dataset.desktopHeight
      }

      video.videoWrapper.style.height = newHeight + "px"

      setTimeout(function () {
        video.videoWrapper.classList.add(classes.wrapperMinHeight)
      }, 600)
      // Set focus on play button, but don't scroll page
      var x = window.scrollX
      var y = window.scrollY
      playButton.focus()
      window.scrollTo(x, y)
    }
  }

  function togglePause(playerId) {
    var pauseButton = videos[playerId].videoWrapper.querySelector(selectors.pauseVideoBtn)
    var paused = pauseButton.classList.contains(classes.userPaused)
    if (paused) {
      pauseButton.classList.remove(classes.userPaused)
      customPlayVideo(playerId)
    } else {
      pauseButton.classList.add(classes.userPaused)
      pauseVideo(playerId)
    }
    pauseButton.setAttribute("aria-pressed", !paused)
  }

  function startVideoOnClick(playerId) {
    var video = videos[playerId]

    // add loading class to wrapper
    video.videoWrapper.classList.add(classes.loading)

    // Explicity set the video wrapper height (needed for height transition)
    video.videoWrapper.style.height = video.videoWrapper.offsetHeight + "px"

    video.status = "open"

    switch (video.type) {
      case "image_with_play":
        privatePlayVideo(playerId, true)
        break
      case "background":
        unsetBackgroundVideo(playerId, video)
        videoPlayers[playerId].unMute()
        privatePlayVideo(playerId, true)
        break
    }

    toggleExpandVideo(playerId, true)

    // esc to close video player
    document.addEventListener("keydown", handleVideoPlayerKeydown)
  }

  var handleVideoPlayerKeydown = function (evt) {
    var playerId = document.activeElement.dataset.controls
    if (evt.keyCode !== 27 || !playerId) {
      return
    }

    closeVideo(playerId)
    toggleExpandVideo(playerId, false)
  }

  function sizeBackgroundVideos() {
    var backgroundVideos = document.querySelectorAll("." + classes.backgroundVideo)
    backgroundVideos.forEach(function (el) {
      sizeBackgroundVideo(el)
    })
  }

  function sizeBackgroundVideo(videoPlayer) {
    if (!youtubeLoaded) {
      return
    }

    if (isMobile()) {
      videoPlayer.style.cssText = null
    } else {
      var videoWrapper = videoPlayer.closest(selectors.videoWrapper)
      var videoWidth = videoWrapper.clientWidth
      var playerWidth = videoPlayer.clientWidth
      var desktopHeight = videoWrapper.dataset.desktopHeight

      // when screen aspect ratio differs from video, video must center and underlay one dimension
      if (videoWidth / videoOptions.ratio < desktopHeight) {
        playerWidth = Math.ceil(desktopHeight * videoOptions.ratio) // get new player width
        var styles =
          "width: " +
          playerWidth +
          "px; height: " +
          desktopHeight +
          "px; left: " +
          (videoWidth - playerWidth) / 2 +
          "px; top: 0;"
        videoPlayer.style.cssText = styles
      } else {
        // new video width < window width (gap to right)
        desktopHeight = Math.ceil(videoWidth / videoOptions.ratio) // get new player height
        var styles2 =
          "width: " +
          videoWidth +
          "px; height: " +
          desktopHeight +
          "px; top: " +
          (desktopHeight - desktopHeight) / 2 +
          "px; left: 0;" // player height is greater, offset top; reset left
        videoPlayer.style.cssText = styles2
      }

      Sunrise.Helpers.prepareTransition(videoPlayer)
      videoWrapper.classList.add(classes.loaded)
    }
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background video to a chrome-only player once played
    var player = document.getElementById(playerId)
    player.classList.remove(classes.backgroundVideo)
    player.classList.add(classes.videoWithImage)

    setTimeout(function () {
      document.getElementById(playerId).style.cssText = null
    }, 600)

    videos[playerId].videoWrapper.classList.remove(classes.backgroundVideoWrapper)
    videos[playerId].videoWrapper.classList.add(classes.playing)

    videos[playerId].status = "open"
  }

  function setBackgroundVideo(playerId) {
    var player = document.getElementById(playerId)
    player.classList.remove(classes.videoWithImage)
    player.classList.add(classes.backgroundVideo)

    videos[playerId].videoWrapper.classList.add(classes.backgroundVideoWrapper)

    videos[playerId].status = "background"
    sizeBackgroundVideo(player)
  }

  function isMobile() {
    return window.innerWidth < window.theme.breakpoints.medium
  }

  var handleWindowResize = Sunrise.Helpers.debounce(function () {
    if (!youtubeLoaded) return
    var key
    var fullscreen = window.innerHeight === screen.height
    sizeBackgroundVideos()

    if (isMobile()) {
      for (key in videos) {
        if (videos.hasOwnProperty(key)) {
          if (videos[key].videoWrapper.classList.contains(classes.playing)) {
            if (!fullscreen) {
              pauseVideo(key)
              setAsPaused(videos[key])
            }
          }
          videos[key].videoWrapper.style.height = document.documentElement.clientWidth / videoOptions.ratio + "px"
        }
      }
      setAutoplaySupport(false)
    } else {
      setAutoplaySupport(true)
      for (key in videos) {
        var videosWithImage = videos[key].videoWrapper.querySelectorAll("." + classes.videoWithImage)
        if (videosWithImage.length) {
          continue
        }
        videoPlayers[key].playVideo()
        setAsPlaying(videos[key])
      }
    }
  }, 200)

  var handleWindowScroll = Sunrise.Helpers.debounce(function () {
    if (!youtubeLoaded) return

    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var videoWrapper = videos[key].videoWrapper
        var condition =
          videoWrapper.getBoundingClientRect().top + window.pageYOffset + videoWrapper.offsetHeight * 0.75 <
            window.pageYOffset ||
          videoWrapper.getBoundingClientRect().top + window.pageYOffset + videoWrapper.offsetHeight * 0.25 >
            window.pageYOffset + window.innerHeight

        // Close the video if more than 75% of it is scrolled out of view
        if (videoWrapper.classList.contains(classes.playing)) {
          if (!condition) return
          closeVideo(key)
          toggleExpandVideo(key, false)
        }
      }
    }
  }, 50)

  function initEvents() {
    var playVideoBtns = document.querySelectorAll(selectors.playVideoBtn)
    var closeVideoBtns = document.querySelectorAll(selectors.closeVideoBtn)
    var pauseVideoBtns = document.querySelectorAll(selectors.pauseVideoBtn)

    playVideoBtns.forEach(function (btn) {
      btn.addEventListener("click", function (evt) {
        var playerId = evt.currentTarget.dataset.controls
        startVideoOnClick(playerId)
      })
    })

    closeVideoBtns.forEach(function (btn) {
      btn.addEventListener("click", function (evt) {
        var playerId = evt.currentTarget.dataset.controls

        evt.currentTarget.blur()
        closeVideo(playerId)
        toggleExpandVideo(playerId, false)
      })
    })

    pauseVideoBtns.forEach(function (btn) {
      btn.addEventListener("click", function (evt) {
        var playerId = evt.currentTarget.dataset.controls
        togglePause(playerId)
      })
    })

    // Listen to resize to keep a background-size:cover-like layout
    window.addEventListener("resize", handleWindowResize)

    window.addEventListener("scroll", handleWindowScroll)
  }

  function createPlayer(key) {
    var args = Object.assign(videoOptions, videos[key])

    args.playerVars.controls = args.controls
    videoPlayers[key] = new YT.Player(key, args)
  }

  function removeEvents() {
    document.removeEventListener("keydown", handleVideoPlayerKeydown)
    window.removeEventListener("resize", handleWindowResize)
    window.removeEventListener("scroll", handleWindowScroll)
  }

  function setButtonLabels(videoWrapper, title) {
    var playButtons = videoWrapper.querySelectorAll(selectors.playVideoBtn)
    var closeButton = videoWrapper.querySelector(selectors.closeVideoBtn)
    var pauseButton = videoWrapper.querySelector(selectors.pauseVideoBtn)
    var closeButtonText = closeButton.querySelector(selectors.fallbackText)

    var pauseButtonStop = pauseButton.querySelector(selectors.pauseVideoStop)
    var pauseButtonStopText = pauseButtonStop.querySelector(selectors.fallbackText)

    var pauseButtonResume = pauseButton.querySelector(selectors.pauseVideoResume)
    var pauseButtonResumeText = pauseButtonResume.querySelector(selectors.fallbackText)

    // Insert the video title retrieved from YouTube into the instructional text
    // for each button
    playButtons.forEach(function (playButton) {
      var playButtonText = playButton.querySelector(selectors.fallbackText)

      playButtonText.textContent = playButtonText.textContent.replace("[video_title]", title)
    })
    closeButtonText.textContent = closeButtonText.textContent.replace("[video_title]", title)
    pauseButtonStopText.textContent = pauseButtonStopText.textContent.replace("[video_title]", title)
    pauseButtonResumeText.textContent = pauseButtonResumeText.textContent.replace("[video_title]", title)
  }

  return {
    init: init,
    editorLoadVideo: editorLoadVideo,
    loadVideos: loadVideos,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents,
  }
})()

// Youtube API callback
function onYouTubeIframeAPIReady() {
  Sunrise.Video.loadVideos()
  Sunrise.ProductVideo.loadVideos(Sunrise.ProductVideo.hosts.youtube)
}

Sunrise.ProductVideo = (function () {
  var videos = {}

  var hosts = {
    html5: "html5",
    youtube: "youtube",
  }

  var selectors = {
    productMediaWrapper: "[data-product-single-media-wrapper]",
  }

  var attributes = {
    enableVideoLooping: "enable-video-looping",
    videoId: "video-id",
  }

  function init(videoContainer, sectionId) {
    if (!videoContainer) {
      return
    }

    var videoElement = videoContainer.querySelector("iframe, video")

    if (!videoElement) {
      return
    }

    var mediaId = videoContainer.getAttribute("data-media-id")

    videos[mediaId] = {
      mediaId: mediaId,
      sectionId: sectionId,
      host: hostFromVideoElement(videoElement),
      container: videoContainer,
      element: videoElement,
      ready: function () {
        createPlayer(this)
      },
    }

    var video = videos[mediaId]

    switch (video.host) {
      case hosts.html5:
        window.Shopify.loadFeatures([
          {
            name: "video-ui",
            version: "1.0",
            onLoad: setupPlyrVideos,
          },
        ])
        Sunrise.LibraryLoader.load("plyrShopifyStyles")
        break
      case hosts.youtube:
        Sunrise.LibraryLoader.load("youtubeSdk", setupYouTubeVideos)
        break
    }
  }

  function setupPlyrVideos(errors) {
    if (errors) {
      fallbackToNativeVideo()
      return
    }

    loadVideos(hosts.html5)
  }

  function setupYouTubeVideos() {
    if (!window.YT.Player) return

    loadVideos(hosts.youtube)
  }

  function createPlayer(video) {
    if (video.player) {
      return
    }

    var productMediaWrapper = video.container.closest(selectors.productMediaWrapper)

    var enableLooping = productMediaWrapper.getAttribute("data-" + attributes.enableVideoLooping)

    switch (video.host) {
      case hosts.html5:
        video.player = new Shopify.Plyr(video.element, {
          loop: { active: enableLooping },
          muted: true,
        })
        break
      case hosts.youtube:
        var videoId = productMediaWrapper.getAttribute("data-" + attributes.videoId)

        video.player = new YT.Player(video.element, {
          videoId: videoId,
          events: {
            onStateChange: function (event) {
              if (event.data === 0 && enableLooping) event.target.seekTo(0)
            },
            onReady: function (event) {
              event.target.mute()
            },
          },
        })
        break
    }

    var pauseVideo = function () {
      if (!video.player) return

      if (video.host === hosts.html5) {
        video.player.pause()
      }

      if (video.host === hosts.youtube && video.player.pauseVideo) {
        video.player.pauseVideo()
      }
    }

    productMediaWrapper.addEventListener("mediaHidden", pauseVideo)
    productMediaWrapper.addEventListener("xrLaunch", pauseVideo)

    productMediaWrapper.addEventListener("mediaVisible", function () {
      if (Sunrise.Helpers.isTouch()) return
      if (!video.player) return

      if (video.host === hosts.html5) {
        video.player.play()
      }

      if (video.host === hosts.youtube && video.player.playVideo) {
        video.player.playVideo()
      }
    })
  }

  function hostFromVideoElement(video) {
    if (video.tagName === "VIDEO") {
      return hosts.html5
    }

    if (video.tagName === "IFRAME") {
      if (/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(video.src)) {
        return hosts.youtube
      }
    }
    return null
  }

  function loadVideos(host) {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key]
        if (video.host === host) {
          video.ready()
        }
      }
    }
  }

  function fallbackToNativeVideo() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key]

        if (video.nativeVideo) continue

        if (video.host === hosts.html5) {
          video.element.setAttribute("controls", "controls")
          video.nativeVideo = true
        }
      }
    }
  }

  function removeSectionVideos(sectionId) {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key]

        if (video.sectionId === sectionId) {
          if (video.player) video.player.destroy()
          delete videos[key]
        }
      }
    }
  }

  return {
    init: init,
    hosts: hosts,
    loadVideos: loadVideos,
    removeSectionVideos: removeSectionVideos,
  }
})()

Sunrise.ProductModel = (function () {
  var modelJsonSections = {}
  var models = {}
  var xrButtons = {}

  var selectors = {
    mediaGroup: "[data-product-single-media-group]",
    xrButton: "[data-shopify-xr]",
  }

  function init(modelViewerContainers, sectionId) {
    modelJsonSections[sectionId] = {
      loaded: false,
    }

    modelViewerContainers.forEach(function (modelViewerContainer, index) {
      var mediaId = modelViewerContainer.getAttribute("data-media-id")
      var modelViewerElement = modelViewerContainer.querySelector("model-viewer")
      var modelId = modelViewerElement.getAttribute("data-model-id")

      if (index === 0) {
        var mediaGroup = modelViewerContainer.closest(selectors.mediaGroup)
        var xrButton = mediaGroup.querySelector(selectors.xrButton)
        xrButtons[sectionId] = {
          element: xrButton,
          defaultId: modelId,
        }
      }

      models[mediaId] = {
        modelId: modelId,
        sectionId: sectionId,
        container: modelViewerContainer,
        element: modelViewerElement,
      }
    })

    window.Shopify.loadFeatures([
      {
        name: "shopify-xr",
        version: "1.0",
        onLoad: setupShopifyXr,
      },
      {
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: setupModelViewerUi,
      },
    ])
    Sunrise.LibraryLoader.load("modelViewerUiStyles")
  }

  function setupShopifyXr(errors) {
    if (errors) return

    if (!window.ShopifyXR) {
      document.addEventListener("shopify_xr_initialized", function () {
        setupShopifyXr()
      })
      return
    }

    for (var sectionId in modelJsonSections) {
      if (modelJsonSections.hasOwnProperty(sectionId)) {
        var modelSection = modelJsonSections[sectionId]

        if (modelSection.loaded) continue
        var modelJson = document.querySelector("#ModelJson-" + sectionId)

        window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML))
        modelSection.loaded = true
      }
    }
    window.ShopifyXR.setupXRElements()
  }

  function setupModelViewerUi(errors) {
    if (errors) return

    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key]
        if (!model.modelViewerUi) {
          model.modelViewerUi = new Shopify.ModelViewerUI(model.element)
        }
        setupModelViewerListeners(model)
      }
    }
  }

  function setupModelViewerListeners(model) {
    var xrButton = xrButtons[model.sectionId]

    model.container.addEventListener("mediaVisible", function () {
      xrButton.element.setAttribute("data-shopify-model3d-id", model.modelId)
      if (Sunrise.Helpers.isTouch()) return
      model.modelViewerUi.play()
    })

    model.container.addEventListener("mediaHidden", function () {
      xrButton.element.setAttribute("data-shopify-model3d-id", xrButton.defaultId)
      model.modelViewerUi.pause()
    })

    model.container.addEventListener("xrLaunch", function () {
      model.modelViewerUi.pause()
    })
  }

  function removeSectionModels(sectionId) {
    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key]
        if (model.sectionId === sectionId) {
          models[key].modelViewerUi.destroy()
          delete models[key]
        }
      }
    }
    delete modelJsonSections[sectionId]
  }

  return {
    init: init,
    removeSectionModels: removeSectionModels,
  }
})()

//Currency Helpers
Sunrise.Currency = (function () {
  var moneyFormat = Sunrise.strings.money_format

  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "")
    }
    var value = ""
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
    var formatString = format || moneyFormat

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ","
      decimal = decimal || "."

      if (isNaN(number) || number === null) {
        return 0
      }

      number = (number / 100.0).toFixed(precision)

      var parts = number.split(".")
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands)
      var centsAmount = parts[1] ? decimal + parts[1] : ""

      return dollarsAmount + centsAmount
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2)
        break
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0)
        break
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",")
        break
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",")
        break
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ")
        break
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'")
        break
    }

    return formatString.replace(placeholderRegex, value)
  }

  return {
    formatMoney: formatMoney,
  }
})()

Sunrise.Variants = (function () {
  function Variants(options) {
    this.container = options.container
    this.product = options.product
    this.originalSelectorId = options.originalSelectorId
    this.enableHistoryState = options.enableHistoryState
    this.singleOptions = this.container.querySelectorAll(options.singleOptionSelector)
    this.currentVariant = this._getVariantFromOptions()

    this.singleOptions.forEach(
      function (option) {
        option.addEventListener("change", this._onSelectChange.bind(this))
      }.bind(this)
    )
  }

  Variants.prototype = Object.assign({}, Variants.prototype, {
    _getCurrentOptions: function () {
      var result = []

      this.singleOptions.forEach(function (option) {
        var type = option.getAttribute("type")
        var isRadioOrCheckbox = type === "radio" || type === "checkbox"

        if (!isRadioOrCheckbox || option.checked) {
          result.push({
            value: option.value,
            index: option.getAttribute("data-index"),
          })
        }
      })

      return result
    },

    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions()
      var variants = this.product.variants

      var found = variants.find(function (variant) {
        return selectedValues.every(function (values) {
          return variant[values.index] === values.value
        })
      })

      return found
    },

    _onSelectChange: function () {
      var variant = this._getVariantFromOptions()

      this.container.dispatchEvent(
        new CustomEvent("variantChange", {
          detail: {
            variant: variant,
          },
          bubbles: true,
          cancelable: true,
        })
      )

      if (!variant) {
        return
      }

      this._updateMasterSelect(variant)
      this._updateImages(variant)
      this._updatePrice(variant)
      this._updateSKU(variant)
      this.currentVariant = variant

      if (this.enableHistoryState) {
        this._updateHistoryState(variant)
      }
    },

    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {}
      var currentVariantImage = this.currentVariant.featured_image || {}

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return
      }

      this.container.dispatchEvent(
        new CustomEvent("variantImageChange", {
          detail: {
            variant: variant,
          },
          bubbles: true,
          cancelable: true,
        })
      )
    },

    _updateSKU: function (variant) {
      if (variant.sku === this.currentVariant.sku) {
        return
      }

      this.container.dispatchEvent(
        new CustomEvent("variantSKUChange", {
          detail: {
            variant: variant,
          },
          bubbles: true,
          cancelable: true,
        })
      )
    },

    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return
      }

      this.container.dispatchEvent(
        new CustomEvent("variantPriceChange", {
          detail: {
            variant: variant,
          },
          bubbles: true,
          cancelable: true,
        })
      )
    },

    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return
      }

      var newurl =
        window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + variant.id
      window.history.replaceState({ path: newurl }, "", newurl)
    },

    _updateMasterSelect: function (variant) {
      var masterSelect = this.container.querySelector(this.originalSelectorId)

      if (!masterSelect) return
      masterSelect.value = variant.id
    },
  })

  return Variants
})()

Sunrise.Product = (function () {
  function Product(container) {
    this.container = container
    var sectionId = container.getAttribute("data-section-id")
    this.zoomPictures = []

    this.selectors = {
      originalSelectorId: "#productSelect-" + sectionId,
      addToCart: "#addToCart-" + sectionId,
      addToCartText: "#addToCartText-" + sectionId,
      priceContainer: "[data-price]",
      productPrice: "[data-regular-price]",
      comparePrice: "[data-sale-price]",
      productSKU: "#productSKU-" + sectionId,
      productStockMsg: "#stockMsg-" + sectionId,
      singleOptionSelector: ".single-option-selector-" + sectionId,
      productThumbImages: ".product-single__thumbnail--" + sectionId,
      productFeaturedMedia: ".product-shot-" + sectionId,
      productThumbsWrapper: ".more-images-" + sectionId,
      productMediaWrapper: "[data-product-single-media-wrapper]",
      productMediaTypeVideo: "[data-product-media-type-video]",
      productMediaTypeModel: "[data-product-media-type-model]",
      imageZoomWrapper: "[data-image-zoom-wrapper]",
      smartPayWrap: ".extra-button-wrap-" + sectionId,
      unitPriceWrap: ".unit-price-wrap",
      storeAvailabilityContainer: "[data-store-availability-container]",
    }

    this.classes = {
      hidden: "hide",
      visibilityHidden: "visibility-hidden",
      jsZoomEnabled: "js-zoom-enabled",
      activeClass: "active-thumb",
    }

    this.settings = {
      sectionId: sectionId,
      enableHistoryState: container.getAttribute("data-enable-history-state") || false,
      namespace: ".product-" + sectionId,
      showPreOrder: container.getAttribute("data-show-preorder"),
      showInventory: container.getAttribute("data-show-inventory-quantity"),
      zoomEnabled: false,
      imageSize: null,
      imageZoomSize: null,
      mediaQuery: "screen and (min-width: 799px)",
    }

    // Stop parsing if we don't have the product json script tag
    var productJson = document.getElementById("ProductJson-" + sectionId)
    if (!productJson || !productJson.innerHTML.length) {
      return
    }

    this.storeAvailabilityContainer = container.querySelector(this.selectors.storeAvailabilityContainer)
    if (this.storeAvailabilityContainer) {
      this.initStoreAvailability()
    }

    this.productSingleObject = JSON.parse(productJson.innerHTML)
    this.settings.imageSize = "1024x1024"
    this.init()
  }

  Product.prototype = Object.assign({}, Product.prototype, {
    init: function init() {
      this.screenWidthChange()
      this.initVariants()
      this.initMoreImages()
      this.initMediaSwitch()
      this.initStoreAvailability()
      this.initProductVideo()
      this.initModelViewerLibraries()
      this.initShopifyXrLaunch()
    },
    screenWidthChange: function screenWidthChange() {
      var self = this
      function checkWidth(mq) {
        if (mq.matches) {
          self.initDesktopLayout()
        } else {
          self.initMobileLayout()
        }
      }
      var mq = window.matchMedia(this.settings.mediaQuery)
      mq.addListener(checkWidth)
      checkWidth(mq)
    },

    initStoreAvailability: function () {
      this.storeAvailability = new Sunrise.StoreAvailability(this.storeAvailabilityContainer)
    },

    initMobileLayout: function initMobileLayout() {
      var zoomWrappers = this.container.querySelectorAll(this.selectors.imageZoomWrapper)
      // destroy zoom
      if (zoomWrappers.length > 0) {
        zoomWrappers.forEach(
          function (element, index) {
            this.destroyZoom(index)
          }.bind(this)
        )
      }
    },

    initDesktopLayout: function initDesktopLayout() {
      var zoomWrappers = this.container.querySelectorAll(this.selectors.imageZoomWrapper)
      if (zoomWrappers.length > 0) {
        // enable zoom
        zoomWrappers.forEach(
          function (element, index) {
            this.enableZoom(element, index)
          }.bind(this)
        )
      }
    },

    initVariants: function initVariants() {
      var options = {
        container: this.container,
        enableHistoryState: this.settings.enableHistoryState,
        product: this.productSingleObject,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
      }

      this.variants = new Sunrise.Variants(options)
      if (this.storeAvailability && this.variants.currentVariant.available) {
        this.storeAvailability.updateContent(this.variants.currentVariant.id)
      }
      this.container.addEventListener("variantChange", this.updateAddToCartButton.bind(this))
      this.container.addEventListener("variantImageChange", this.updateMedia.bind(this))
      this.container.addEventListener("variantPriceChange", this.updatePrices.bind(this))
      this.container.addEventListener("variantSKUChange", this.updateSKU.bind(this))
    },
    initMediaSwitch: function initMediaSwitch(event) {
      if (!this.container.querySelector(this.selectors.productThumbImages)) return
      var self = this
      var thumbsWrapper = this.container.querySelector(this.selectors.productThumbsWrapper)
      var thumbImages = thumbsWrapper.querySelectorAll(this.selectors.productThumbImages)

      //scroll to active thumb if set
      var activeThumb = thumbsWrapper.querySelector(".active-thumb")
      if (thumbsWrapper.classList.contains("flickity-enabled")) {
        scrolltoActiveImage(thumbsWrapper, activeThumb.getAttribute("image-index"))
      }

      thumbImages.forEach(function (el) {
        el.addEventListener("click", function (e) {
          e.preventDefault()
          var mediaId = el.getAttribute("data-thumbnail-id")
          self.switchMedia(mediaId)
          self.setActiveThumbnail(mediaId)
        })
      })
    },

    switchMedia: function switchMedia(mediaId) {
      var currentMedia = this.container.querySelector(
        this.selectors.productMediaWrapper + ":not(." + this.classes.hidden + ")"
      )

      var newMedia = this.container.querySelector(
        this.selectors.productMediaWrapper + "[data-media-id='" + mediaId + "']"
      )

      var otherMedia = this.container.querySelectorAll(
        this.selectors.productMediaWrapper + ":not([data-media-id='" + mediaId + "'])"
      )

      currentMedia.dispatchEvent(
        new CustomEvent("mediaHidden", {
          bubbles: true,
          cancelable: true,
        })
      )

      newMedia.classList.remove(this.classes.hidden)
      newMedia.dispatchEvent(
        new CustomEvent("mediaVisible", {
          bubbles: true,
          cancelable: true,
        })
      )
      newMedia.setAttribute("tabindex", "0")

      otherMedia.forEach(
        function (el) {
          el.classList.add(this.classes.hidden)
          el.setAttribute("tabindex", "-1")
        }.bind(this)
      )
    },

    setActiveThumbnail: function setActiveThumbnail(mediaId) {
      // If there is no element passed, find it by the current product image
      if (typeof mediaId === "undefined") {
        var productMediaWrapper = this.container.querySelector(this.selectors.productMediaWrapper + ":not(.hide)")
        if (!productMediaWrapper) return
        mediaId = productMediaWrapper.getAttribute("data-thumbnail-id")
      }

      var thumbnailWrappers = this.container.querySelectorAll(this.selectors.productThumbsWrapper)
      var productThumbImages = document.querySelectorAll(this.selectors.productThumbImages)
      productThumbImages.forEach(
        function (el) {
          el.classList.remove(this.classes.activeClass)
          el.removeAttribute("aria-current")
        }.bind(this)
      )

      var activeThumbnail
      thumbnailWrappers.forEach(
        function (el) {
          var current = el.querySelector(this.selectors.productThumbImages + "[data-thumbnail-id='" + mediaId + "']")
          if (current) {
            activeThumbnail = current
            activeThumbnail.classList.add(this.classes.activeClass)
            activeThumbnail.setAttribute("aria-current", true)
            if (el.classList.contains("flickity-enabled")) {
              scrolltoActiveImage(el, activeThumbnail.getAttribute("data-image-index"))
            }
          }
        }.bind(this)
      )
    },

    updateMedia: function updateMedia(evt) {
      var variant = evt.detail.variant
      var mediaId = variant.featured_media.id
      var sectionMediaId = this.settings.sectionId + "-" + mediaId

      this.switchMedia(sectionMediaId)
      this.setActiveThumbnail(sectionMediaId)
    },

    updateSKU: function updateSKU(event) {
      var variant = event.detail.variant
      var variantSKU = variant.sku || ""
      var sku = document.querySelector(this.selectors.productSKU)
      if (!sku) return
      if (variantSKU.trim().length < 1) {
        sku.innerHTML = ""
        sku.classList.add("hide")
      } else {
        sku.innerHTML = Sunrise.strings.sku + variantSKU
        sku.classList.remove("hide")
      }
    },

    updateStoreAvailabilityContent: function (evt) {
      if (!this.storeAvailability) {
        return
      }

      var variant = event.detail.variant

      if (!variant) {
        this.storeAvailability.clearContent()
        return
      }

      this.storeAvailability.updateContent(variant.id)
    },

    updateAddToCartButton: function updateAddToCartButton(event) {
      var variant = event.detail.variant
      var originalSelector = document.querySelector(this.selectors.originalSelectorId)
      var smartPayWrap = document.querySelector(this.selectors.smartPayWrap)
      var stockMsg = document.querySelector(this.selectors.productStockMsg)
      var addToCartButton = document.querySelector(this.selectors.addToCart)
      var addToCartButtonText = addToCartButton.querySelector(this.selectors.addToCartText)
      if (smartPayWrap) smartPayWrap.classList.add("hide")
      if (stockMsg) {
        stockMsg.classList.add("hide")
        stockMsg.innerHTML = ""
      }
      if (variant) {
        if (variant.available) {
          var selectedOption = originalSelector.querySelector('[value="' + variant.id + '"]')
          var invQty = selectedOption.getAttribute("data-stk")
          var invPolicy = selectedOption.getAttribute("data-policy")
          // Valid variant, enable buttons
          if (smartPayWrap) smartPayWrap.classList.remove("hide")
          addToCartButton.removeAttribute("disabled")
          addToCartButtonText.innerHTML = Sunrise.strings.add_to_cart
          // Stock message
          if (
            this.settings.showPreOrder == "yes" &&
            variant.inventory_management == "shopify" &&
            invQty <= 0 &&
            invPolicy == "continue"
          ) {
            // Show pre-order message
            stockMsg.innerHTML = "<div class='var-msg'>" + Sunrise.strings.preorder_msg + "</div>"
            stockMsg.classList.remove("hide")
          } else if (this.settings.showInventory == "yes" && variant.inventory_management == "shopify") {
            // show stock qty
            stockMsg.innerHTML =
              "<div class='var-msg'>" +
              Sunrise.strings.product_availability +
              " " +
              invQty +
              " " +
              Sunrise.strings.product_in_stock +
              "</div>"
            stockMsg.classList.remove("hide")
          }
        } else {
          // Variant doesn't exist, disable submit button and change the text
          addToCartButton.setAttribute("disabled", "disabled")
          addToCartButtonText.innerHTML = Sunrise.strings.sold_out
          if (smartPayWrap) smartPayWrap.classList.add("hide")
        }
      } else {
        addToCartButton.setAttribute("disabled", "disabled")
        addToCartButtonText.innerHTML = Sunrise.strings.unavailable
        if (smartPayWrap) smartPayWrap.classList.add("hide")
      }
      this.updateStoreAvailabilityContent(event)
    },

    updatePrices: function updatePrices(event) {
      var variant = event.detail.variant
      var priceContainer = this.container.querySelector(this.selectors.priceContainer)
      var comparePrice = priceContainer.querySelector(this.selectors.comparePrice)
      var unitPriceWrap = priceContainer.querySelector(this.selectors.unitPriceWrap)
      var productPrice = priceContainer.querySelector(this.selectors.productPrice)

      if (comparePrice) comparePrice.classList.add("hide")
      if (unitPriceWrap) unitPriceWrap.classList.add("hide")

      if (variant) {
        var price = Sunrise.Currency.formatMoney(variant.price, Sunrise.strings.money_format)
        productPrice.innerHTML = "<span class=price-money>" + price + "</span>"

        // Update and show the product compare price if necessary
        if (comparePrice) {
          if (variant.compare_at_price > variant.price) {
            comparePrice.innerHTML =
              "<span class=price-money>" +
              Sunrise.Currency.formatMoney(variant.compare_at_price, Sunrise.strings.money_format) +
              "</span>"
            comparePrice.classList.remove("hide")
          } else {
            comparePrice.classList.add("hide")
          }
        }

        if (unitPriceWrap) {
          if (variant.unit_price) {
            var unitPrice =
              Sunrise.Currency.formatMoney(variant.unit_price, Sunrise.strings.money_format) +
              unitPriceSeparator +
              this.getBaseUnit(variant)
            unitPriceWrap.innerHTML = unitPrice
            unitPriceWrap.classList.remove("hide")
          }
        }
      }
    },

    getBaseUnit: function getBaseUnit(variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit
    },

    initProductVideo: function initProductVideo() {
      var sectionId = this.settings.sectionId
      var productMediaTypeVideo = this.container.querySelectorAll(this.selectors.productMediaTypeVideo)
      productMediaTypeVideo.forEach(function (el) {
        Sunrise.ProductVideo.init(el, sectionId)
      })
    },

    initModelViewerLibraries: function initModelViewerLibraries() {
      var modelViewerElements = this.container.querySelectorAll(this.selectors.productMediaTypeModel)
      if (modelViewerElements.length < 1) return
      Sunrise.ProductModel.init(modelViewerElements, this.settings.sectionId)
    },

    initShopifyXrLaunch: function initShopifyXrLaunch() {
      var self = this
      document.addEventListener("shopify_xr_launch", function (e) {
        var currentMedia = self.container.querySelector(
          self.selectors.productMediaWrapper + ":not(." + self.classes.hidden + ")"
        )
        currentMedia.dispatchEvent(
          new CustomEvent("xrLaunch", {
            bubbles: true,
            cancelable: true,
          })
        )
      })
    },

    initMoreImages: function initMoreImages() {
      var thumbCount = this.container.querySelector(this.selectors.productThumbsWrapper).querySelectorAll(this.selectors.productThumbImages).length
      _initMoreImages(this.container.querySelector(this.selectors.productThumbsWrapper),thumbCount)
    },

    enableZoom: function enableZoom(el, index) {
      this.zoomPictures[index] = new Sunrise.Zoom(el)
    },

    destroyZoom: function destroyZoom(index) {
      if (this.zoomPictures.length === 0) return
      this.zoomPictures[index].unload()
    },
  })

  function _initMoreImages(el, thumbCount) {
    if (!el) return
    var productPageThumbs = el
    var groupCells = false

    if(thumbCount < 4){
      // disable flickity nav if less than 4 thumbs
      groupCells = true
    }

    var options = {
      selector: ".product-image-small",
      prevNextButtons: true,
      pageDots: false,
      freeScroll: true,
      wrapAround: true,
      autoPlay: false,
      cellAlign: "left",
      contain: true,
      watchCSS: true,
      groupCells: groupCells,
      imagesLoaded: true,
    }

    var f = new Flickity(productPageThumbs, options)
  }

  function scrolltoActiveImage(el, imageIndex) {
    if (el === undefined) {
      return
    }
    var productSlider = Flickity.data(el)
    productSlider.select(imageIndex)
  }

  return Product
})()

Sunrise.Zoom = (function () {
  var selectors = {
    imageZoom: "[data-image-zoom]",
  }

  var classes = {
    zoomImg: "zoomImg",
  }

  var attributes = {
    imageZoomTarget: "data-image-zoom-target",
  }

  function Zoom(container) {
    this.container = container
    this.cache = {}
    this.url = container.dataset.zoom

    this._cacheSelectors()

    if (!this.cache.sourceImage) return

    this._duplicateImage()
  }

  Zoom.prototype = Object.assign({}, Zoom.prototype, {
    _cacheSelectors: function () {
      this.cache = {
        sourceImage: this.container.querySelector(selectors.imageZoom),
      }
    },

    _init: function () {
      var targetWidth = this.cache.targetImage.width
      var targetHeight = this.cache.targetImage.height

      if (this.cache.sourceImage === this.cache.targetImage) {
        this.sourceWidth = targetWidth
        this.sourceHeight = targetHeight
      } else {
        this.sourceWidth = this.cache.sourceImage.width
        this.sourceHeight = this.cache.sourceImage.height
      }

      this.xRatio = (this.cache.sourceImage.width - targetWidth) / this.sourceWidth
      this.yRatio = (this.cache.sourceImage.height - targetHeight) / this.sourceHeight
    },

    _start: function (e) {
      this._init()
      this._move(e)
    },

    _stop: function () {
      this.cache.targetImage.style.opacity = 0
    },

    /**
     * Sets the correct coordinates top and left position in px
     * It sets a limit within between 0 and the max height of the image
     * So when the mouse leaves the target image, it could
     * never go above or beyond the target image zone
     */
    _setTopLeftMaxValues: function (top, left) {
      return {
        left: Math.max(Math.min(left, this.sourceWidth), 0),
        top: Math.max(Math.min(top, this.sourceHeight), 0),
      }
    },

    _move: function (e) {
      // get left and top position within the "source image" zone
      var left = e.pageX - (this.cache.sourceImage.getBoundingClientRect().left + window.scrollX)
      var top = e.pageY - (this.cache.sourceImage.getBoundingClientRect().top + window.scrollY)
      // make sure the left and top position don't go
      // above or beyond the target image zone
      var position = this._setTopLeftMaxValues(top, left)

      top = position.top
      left = position.left

      this.cache.targetImage.style.left = -(left * -this.xRatio) + "px"
      this.cache.targetImage.style.top = -(top * -this.yRatio) + "px"
      this.cache.targetImage.style.opacity = 1
    },

    /**
     * This loads a high resolution image
     * via the data attributes url
     * It adds all necessary CSS styles and adds to the container
     */
    _duplicateImage: function () {
      this._loadImage()
        .then(
          function (image) {
            this.cache.targetImage = image
            image.style.width = image.width + "px"
            image.style.height = image.height + "px"
            image.style.position = "absolute"
            image.style.maxWidth = "none"
            image.style.maxHeight = "none"
            image.style.opacity = 0
            image.style.border = "none"
            image.style.left = 0
            image.style.top = 0

            this.container.appendChild(image)

            this._init()

            this._start = this._start.bind(this)
            this._stop = this._stop.bind(this)
            this._move = this._move.bind(this)

            this.container.addEventListener("mouseenter", this._start)
            this.container.addEventListener("mouseleave", this._stop)
            this.container.addEventListener("mousemove", this._move)

            this.container.style.position = "relative"
            this.container.style.overflow = "hidden"
          }.bind(this)
        )
        .catch(function (error) {
          console.warn("Error fetching image", error)
        })
    },

    _loadImage: function () {
      return new Promise(
        function (resolve, reject) {
          var image = new Image()
          image.setAttribute("role", "presentation")
          image.setAttribute(attributes.imageZoomTarget, true)
          image.classList.add(classes.zoomImg)
          image.src = this.url

          image.addEventListener("load", function () {
            resolve(image)
          })

          image.addEventListener("error", function (error) {
            reject(error)
          })
        }.bind(this)
      )
    },

    unload: function () {
      var targetImage = this.container.querySelector("[" + attributes.imageZoomTarget + "]")
      if (targetImage) {
        targetImage.remove()
      }

      this.container.removeEventListener("mouseenter", this._start)
      this.container.removeEventListener("mouseleave", this._stop)
      this.container.removeEventListener("mousemove", this._move)
    },
  })

  return Zoom
})()

Sunrise.initAccordions = function () {
  // Toggle accordions - gt-accordion for backwards compatibility
  document.querySelectorAll(".gt-accordion h4").forEach(function (el) {
    var state = false
    el.addEventListener("click", function (e) {
      var answer = e.target.nextElementSibling
      if (!answer) return
      state = !state
      Sunrise.Helpers.slideToggle(answer, 300)
      e.target.classList.toggle("active", state)
      e.target.setAttribute("aria-expanded", state)
    })
  })
}

Sunrise.Sidebar = function () {
  var selectors = {
    sideBar: "#sidebar",
    topMenu: "nav.top-menu",
    sideMenu: "nav#menu",
  }
  var sideBar = document.querySelector(selectors.sideBar)
  var topMenu = document.querySelector(selectors.topMenu)
  var sideMenu = document.querySelector(selectors.sideMenu)
  var keepMenuOpen = "true"
  var sideMenuHandle = ""

  if (sideMenu) {
    keepMenuOpen = sideMenu.getAttribute("data-keep-open")
    sideMenuHandle = sideMenu.getAttribute("data-menuchosen")
  } else {
    // add html so that mobile menu still works when side menu section is hidden
    var sidebarHtml = sideBar.innerHTML
    var htmlToAdd =
      '<style>#side-menu a.newfont{font-size: 20px;}</style><nav id="menu" role="navigation" aria-label="Side menu"><ul id="side-menu"><div class="side-menu-mobile hide show-mobile"></div></ul></nav>'
    sideBar.innerHTML = htmlToAdd + sideBar.innerHTML
  }

  if (topMenu) {
    var topMenuHandle = topMenu.getAttribute("data-menuchosen")
    var targetDiv = sideBar.querySelector(".side-menu-mobile")

    sideBar.querySelectorAll("li.from-top-menu").forEach(function (el) {
      return el.remove()
    })

    if (sideMenuHandle !== topMenuHandle) {
      // append top nav to side menu for mobile view
      var topMenuClone = topMenu.querySelector("ul").cloneNode(true)
      topMenuClone.querySelectorAll("li.from-top-menu").forEach(function (el) {
        targetDiv.appendChild(el)
      })
    }
  }

  if (keepMenuOpen) {
    var currentUrl = window.location.pathname
    if (currentUrl != window.routes.rootUrl) {
      sideBar.querySelectorAll("li.original-li").forEach(function (menuLink) {
        var activeChildren = menuLink.querySelector(".active")
        if (activeChildren) {
          menuLink.querySelector(".dropdown-toggle").click()
        }
      })
      sideBar.querySelectorAll("li.active > a .dropdown-toggle").forEach(function (el) {
        return el.setAttribute("aria-expanded", true)
      })
    }
  }
}

Sunrise.Slideshow = (function () {
  function Slideshow(container) {
    this.container = container
    this.slider = this.container.querySelector("[data-slider]")
    if (!this.slider) return

    this.slideCount = parseInt(this.slider.dataset.count, 10)
    this.showSliderNav = false
    this.autoPlay = false

    if (this.slider.dataset.autoplay === "true") {
      this.autoPlay = parseInt(this.slider.dataset.speed, 10)
    }

    if (this.slideCount > 1) {
      this.showSliderNav = true
    }

    this.options = {
      selector: ".slide",
      prevNextButtons: this.showSliderNav,
      pageDots: this.showSliderNav,
      freeScroll: false,
      wrapAround: true,
      autoPlay: this.autoPlay,
      cellAlign: "left",
      contain: true,
      adaptiveHeight: false,
      imagesLoaded: true,
    }

    this.flkty = new Flickity(this.slider, this.options)

    this.slider.querySelectorAll(".slide").forEach(function (el) {
      return el.classList.remove("is-hidden")
    })
  }

  Slideshow.prototype = Object.assign({}, Slideshow.prototype, {
    onDeselect: function (e) {
      if (this.autoPlay) {
        this.flkty.playPlayer()
      }
    },
    onBlockSelect: function (e) {
      this.flkty.stopPlayer()
      this.flkty.select(e.target.dataset.index)
    },
  })

  return Slideshow
})()

Sunrise.LogoList = (function () {
  function LogoList(container) {
    this.container = container
    this.slider = this.container.querySelector("[data-slider-logolist]")
    if (!this.slider) return

    this.logoCount = parseInt(this.slider.dataset.count, 10)
    this.autoPlay = false

    if (this.slider.dataset.autoplay != "false") {
      this.autoPlay = parseInt(this.slider.dataset.autoplay, 10)
    }

    this.options = {
      selector: ".logo-list-item",
      prevNextButtons: true,
      pageDots: false,
      freeScroll: true,
      wrapAround: true,
      autoPlay: this.autoPlay,
      cellAlign: "left",
      contain: true,
      adaptiveHeight: false,
      imagesLoaded: true,
    }

    if (this.logoCount > 5) {
      this.slider.classList.remove("is-static")
      this.flkty = new Flickity(this.slider, this.options)
    }

    this.slider.querySelectorAll(".logo-list-item").forEach(function (el) {
      return el.classList.remove("is-hidden")
    })
  }

  LogoList.prototype = Object.assign({}, LogoList.prototype, {
    onDeselect: function (e) {
      if (!this.flkty) return
      if (this.logoCount > 5) {
        if (this.autoPlay) {
          this.flkty.playPlayer()
        }
      }
    },
    onBlockSelect: function (e) {
      if (this.flkty) {
        this.flkty.stopPlayer()
        this.flkty.select(e.target.dataset.index)
      }
    },
  })

  return LogoList
})()

Sunrise.FeaturedVideo = (function () {
  function FeaturedVideo(container) {
    if (Shopify.designMode) {
      // Only when in the theme editor...
      // Set video src so that new videos appear
      var videos, i
      this.container = container
      videos = this.container.querySelectorAll(".lazy")
      for (i = 0; i < videos.length; ++i) {
        videos[i].src = videos[i].dataset.src
      }
    }
  }

  return FeaturedVideo
})()

Sunrise.Cart = (function () {
  function Cart(container) {
    this.container = container
    var cartForm = this.container.querySelector("#cartform")
    if (!cartForm) return

    var qtyFields = cartForm.querySelectorAll("input.quantity")
    var resetCart = false

    function isQuantityTooHigh(el) {
      if (el.dataset.managed == "shopify" && el.dataset.policy == "deny") {
        var itemStock = parseInt(el.dataset.stk, 10)
        var itemQuantity = parseInt(el.value, 10)
        if (itemQuantity > itemStock) {
          return true
        }
      } else {
        return false
      }
    }

    qtyFields.forEach(function (el) {
      if (isQuantityTooHigh(el)) {
        el.value = parseInt(el.dataset.stk, 10)
        resetCart = true
      }
    })

    if (resetCart) {
      alert(Sunrise.strings.cart_low_stock_message)
      cartForm.querySelector(".cart-update").click()
    }

    qtyFields.forEach(function (el) {
      el.addEventListener("blur", function (e) {
        if (isQuantityTooHigh(el)) {
          el.value = parseInt(el.dataset.stk, 10)
          alert(Sunrise.strings.stock_reduced_message + " " + el.value)
        }
      })
    })

    if (window.Shopify.Cart) {
      Shopify.Cart.ShippingCalculator.show()
    }
  }

  Cart.prototype = Object.assign({}, Cart.prototype, {
    onUnload: function () {
      // nothing to do on unload
    },
  })

  return Cart
})()

Sunrise.Footer = (function () {
  function Footer(container) {
    this.container = container
  }

  Footer.prototype = Object.assign({}, Footer.prototype, {
    onDeselect: function (e) {},

    onUnload: function () {
      // make sure back to top icon appears
      Sunrise.Helpers.triggerEvent(window, "scroll")
    },
  })

  return Footer
})()

Sunrise.Header = (function () {
  function Header(container) {
    this.container = container
  }

  Header.prototype = Object.assign({}, Header.prototype, {
    onSelect: function (e) {},

    onDeselect: function (e) {
      Sunrise.Sidebar()
    },

    onUnload: function () {},
  })

  return Header
})()

Sunrise.Maps = (function () {
  var config = {
    zoom: 14,
  }
  var apiStatus = null
  var mapsToLoad = []

  var errors = {
    addressNoResults: Sunrise.strings.addressNoResults,
    addressQueryLimit: Sunrise.strings.addressQueryLimit,
    addressError: Sunrise.strings.addressError,
    authError: Sunrise.strings.authError,
  }

  var selectors = {
    section: '[data-section-type="map"]',
    map: "[data-map]",
    mapOverlay: "[data-map-overlay]",
  }

  var classes = {
    mapError: "map-section--load-error",
    errorMsg: "map-section__error errors text-center",
  }

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  window.gm_authFailure = function () {
    if (!Shopify.designMode) {
      return
    }

    document.querySelector(selectors.section).classList.add(classes.mapError)
    document.querySelector(selectors.map).remove()
    document
      .querySelector(selectors.mapOverlay)
      .insertAdjacentHTML("afterend", '<div class="' + classes.errorMsg + '">' + Sunrise.strings.authError + "</div>")
  }

  function Map(container) {
    this.map = container.querySelector(selectors.map)
    if (!this.map) return
    this.key = this.map.dataset.apiKey

    if (typeof this.key === "undefined") {
      return
    }

    if (apiStatus === "loaded") {
      this.createMap()
    } else {
      mapsToLoad.push(this)

      if (apiStatus !== "loading") {
        apiStatus = "loading"
        if (typeof window.google === "undefined") {
          Sunrise.Helpers.getScript("https://maps.googleapis.com/maps/api/js?key=" + this.key).then(function () {
            apiStatus = "loaded"
            initAllMaps()
          })
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    mapsToLoad.forEach(function (map) {
      map.createMap()
    })
  }

  function geolocate(map) {
    return new Promise(function (resolve, reject) {
      var geocoder = new google.maps.Geocoder()
      var address = map.dataset.addressSetting

      geocoder.geocode({ address: address }, function (results, status) {
        if (status !== google.maps.GeocoderStatus.OK) {
          reject(status)
        }

        resolve(results)
      })
    })
  }

  Map.prototype = Object.assign({}, Map.prototype, {
    createMap: function () {
      return geolocate(this.map)
        .then(
          function (results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true,
            }

            var map = (this.map = new google.maps.Map(this.map, mapOptions))
            var center = (this.center = map.getCenter())
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter(),
            })

            google.maps.event.addDomListener(
              window,
              "resize",
              Sunrise.Helpers.debounce(
                function () {
                  google.maps.event.trigger(map, "resize")
                  map.setCenter(center)
                  //map.setAttribute("style","")
                }.bind(this),
                250
              )
            )
          }.bind(this)
        )
        .catch(
          function () {
            var errorMessage

            switch (status) {
              case "ZERO_RESULTS":
                errorMessage = errors.addressNoResults
                break
              case "OVER_QUERY_LIMIT":
                errorMessage = errors.addressQueryLimit
                break
              case "REQUEST_DENIED":
                errorMessage = errors.authError
                break
              default:
                errorMessage = errors.addressError
                break
            }

            // Show errors only to merchant in the editor.
            if (Shopify.designMode) {
              this.map.parentNode.classList.add(classes.mapError)
              this.map.parentNode.innerHTML = '<div class="' + classes.errorMsg + '">' + errorMessage + "</div>"
            }
          }.bind(this)
        )
    },

    onUnload: function () {
      if (this.map) {
        google.maps.event.clearListeners(this.map, "resize")
      }
    },
  })

  return Map
})()

Sunrise.predictiveSearch = function () {
  var predictiveSearchEnabled = window.theme.settings.predictiveSearchEnabled

  var selectors = {
    topSearchWrapper: "[data-top-search-wrapper]",
    mainSearchWrapper: "[data-main-search-wrapper]",
    mainSearchField: "[data-main-search-field]",
    topSearchField: "[data-top-search-field]",
    searchFormWrap: ".search-form-wrap",
    searchForm: ".search-form",
    buttonSubmit: ".search-submit",
    buttonReset: ".search-form-clear",
    buttonClose: ".search-bar-close",
    buttonSearchFor: ".do-search",
    searchField: 'input[name="q"]',
    resultsContainer: ".predictive-search-wrapper",
    results: "ul.predictive-results",
    resultsLi: "li.search-result-single",
  }

  var classes = {
    hasFocus: "has-focus",
    searchPopulated: "input-has-text",
    isFixed: "is-fixed",
    resultSelected: "result-selected",
    hideResults: "hide-results",
    topSearchWrapper: "predictive-search-wrapper-top",
    buttonResults: "do-search",
  }

  if (!document.querySelector(selectors.topSearchWrapper)) {
    return
  }

  var keys = { enter: 13, esc: 27, space: 32, up: 38, down: 40, tab: 9, left: 37, right: 39, shift: 16 }

  var translations = JSON.parse(document.querySelector(selectors.topSearchWrapper).getAttribute("data-translations"))

  function showTopSearch(event) {
    var topSearchWrapper = document.querySelector(selectors.topSearchWrapper)
    var searchField = topSearchWrapper.querySelector(selectors.topSearchField)

    event.preventDefault()

    document.documentElement.classList.add(classes.isFixed)
    document.body.classList.add(classes.isFixed)

    Sunrise.Helpers.trapFocus(selectors.topSearchWrapper)
    topSearchWrapper.style.display = "block"
    searchField.focus()

    var searchText = searchField.value.trim()

    if (searchText) {
      topSearchWrapper.classList.add(classes.searchPopulated)
      doSearch(searchField)
    } else {
      topSearchWrapper.classList.remove(classes.searchPopulated)
    }
  }

  function showMainSearch(event, searchField) {
    if (searchField.value.trim()) {
      document.querySelector(selectors.mainSearchWrapper).classList.remove(classes.hideResults)
      doSearch(searchField)
    }
  }

  function closeTopSearch(event) {
    event.preventDefault()
    document.documentElement.classList.remove(classes.isFixed)
    document.body.classList.remove(classes.isFixed)
    document.querySelector(selectors.topSearchWrapper).style.display = "none"
  }

  function resetSearch(event, resetButton) {
    event.preventDefault()
    var wrapper = resetButton.closest(selectors.searchFormWrap)
    wrapper.classList.remove(classes.searchPopulated)
    var searchField = wrapper.querySelector(selectors.searchField)
    searchField.value = ""
    searchField.focus()
    wrapper.querySelector(selectors.resultsContainer).innerHTML = ""
  }

  function toggleSearch(event, searchField) {
    var wrapper = searchField.closest(selectors.searchFormWrap)
    if (searchField.value.trim()) {
      wrapper.classList.add(classes.searchPopulated)
      searchField.setAttribute("aria-expanded", "true")
    } else {
      wrapper.classList.remove(classes.searchPopulated)
      searchField.setAttribute("aria-expanded", "false")
    }
  }

  function focusFirstResult(event, searchField) {
    switch (event.keyCode) {
      case keys.down:
        var wrapper = searchField.closest(selectors.searchFormWrap)
        var results = wrapper.querySelector(selectors.results)
        var singleResult = results.querySelector(selectors.resultsLi)
        singleResult.classList.add(classes.resultSelected)
        var resultLink = singleResult.querySelector("a")
        if (resultLink) {
          resultLink.classList.add(classes.resultSelected)
          resultLink.focus()
        }
        break
      case keys.esc:
        closeTopSearch(event)
        break
      default:
        return
    }
  }

  function navigateResults(event, result) {
    var wrapper = result.closest(selectors.searchFormWrap)
    var searchField = wrapper.querySelector(selectors.searchField)
    var closestLi = result.closest(selectors.resultsLi)
    var currentIndex = closestLi.getAttribute("data-index")
    var indexLimit = parseInt(wrapper.getAttribute("data-resultcount"), 10)
    var singleResult
    var singleResultLink

    switch (event.keyCode) {
      case keys.down:
        if (currentIndex == indexLimit || result.classList.contains(classes.buttonResults)) {
          //at last item;
          return
        }
        closestLi.classList.remove(classes.resultSelected)
        closestLi.querySelector("a").classList.remove(classes.resultSelected)
        currentIndex++
        singleResult = closestLi.nextElementSibling
        while (singleResult) {
          // skip category headers and find a valid result
          if (singleResult.matches(selectors.resultsLi)) break
          singleResult = singleResult.nextElementSibling
        }
        singleResult.classList.add(classes.resultSelected)
        singleResultLink = singleResult.querySelector("a")
        singleResultLink.classList.add(classes.resultSelected)
        singleResultLink.focus()
        break
      case keys.up:
        if (currentIndex == 0) {
          closestLi.classList.remove(classes.resultSelected)
          closestLi.querySelector("a").classList.remove(classes.resultSelected)
          searchField.focus()
          return
        }
        closestLi.classList.remove(classes.resultSelected)
        closestLi.querySelector("a").classList.remove(classes.resultSelected)
        currentIndex--
        singleResult = closestLi.previousElementSibling
        while (singleResult) {
          // skip category headers and find a valid result
          if (singleResult.matches(selectors.resultsLi)) break
          singleResult = singleResult.previousElementSibling
        }
        singleResult.classList.add(classes.resultSelected)
        singleResult.querySelector("a").classList.add(classes.resultSelected)
        singleResult.querySelector("a").focus()
        break
      case keys.esc:
        closeTopSearch(event)
        break
      default:
        return
    }
  }

  function doSearch(searchField) {
    if (!predictiveSearchEnabled) {
      return
    }

    var wrapper = searchField.closest(selectors.searchFormWrap)
    var searchString = searchField.value.trim()
    var submitButtonIcon = wrapper.querySelector(selectors.buttonSubmit + " path")
    var targetDiv = wrapper.querySelector(selectors.resultsContainer)
    var containerId = wrapper.getAttribute("id") + "-"
    var counter = 0
    var suggestions = ""
    var searchUrl = window.routes.searchUrl + "/suggest.json"

    if (searchString === "") {
      wrapper.classList.remove(classes.searchPopulated)
      targetDiv.innerHTML = ""
      return
    }

    submitButtonIcon.classList.add("animated-looped-fast", "pulse")

    var predictiveResults = targetDiv.querySelector(selectors.results)
    if (!predictiveResults) {
      targetDiv.innerHTML = "<ul id='" + containerId + "results' role='list' class='predictive-results'></ul>"
    }

    var apiUrl = searchUrl + "?q=" + searchString

    fetch(apiUrl)
      .then(function (response) {
        if (response.ok) {
          return response.json()
        } else {
          return response.json().then(function (err) {
            return Promise.reject(err)
          })
        }
      })
      .then(function (data) {
        handleResults(data.resources.results)
      })
      .catch(function (err) {
        console.log(err)
      })

    function compileResults(results, categoryTitle) {
      if (!results.length) return

      var sectionHeading, thumbnail, price, comparePrice, itemPrice, oldPrice, vendor, itemTitle

      if (categoryTitle == "queries") {
        // queries and collections share same heading
        sectionHeading = translations["suggestions"]
      } else {
        sectionHeading = translations[categoryTitle]
      }

      // only add h4 heading if it doesn't exist already
      if (suggestions.length) {
        if (suggestions.indexOf("<h4>" + sectionHeading) < 0) {
          suggestions += '<li class="search-category"><h4>' + sectionHeading + "</h4></li>"
        }
      } else {
        suggestions += '<li class="search-category"><h4>' + sectionHeading + "</h4></li>"
      }

      results.forEach(function (el) {
        thumbnail = ""
        if (el.hasOwnProperty("featured_image")) {
          if (el.featured_image.url != null) {
            var smallImage = Sunrise.Images.getSizedImageUrl(el.featured_image.url, "120x120")
            thumbnail = '<div class="thumbnail"><img class="" src="' + smallImage + '" /></div>'
          }
        }

        price = ""
        comparePrice = ""
        itemPrice = ""
        vendor = ""
        itemTitle = ""
        oldPrice = ""

        if (window.theme.settings.predictiveSearchShowPrice) {
          if (el.price != undefined) {
            price = Sunrise.Currency.formatMoney(el.price, Sunrise.strings.money_format)
            if (el.compare_at_price_min != "0.00") {
              oldPrice = Sunrise.Currency.formatMoney(el.compare_at_price_min, Sunrise.strings.money_format)
              comparePrice = '<del><span class="price-money">' + oldPrice + "</span></del>"
            }
            itemPrice =
              '<span class="search-price"><span class="price-money">' + price + "</span>" + comparePrice + "</span>"
          }
        }

        if (window.theme.settings.predictiveSearchShowVendor) {
          if (el.vendor != undefined) {
            vendor = '<span class="search-vendor">' + el.vendor + "</span>"
          }
        }

        if (categoryTitle == "queries") {
          itemTitle =
            '<div class="search-result-column"><div class="search-item-title search-query-result">' +
            el.styled_text +
            "</div>" +
            "</div>"
        } else {
          itemTitle =
            '<div class="search-result-column"><div class="search-item-title">' +
            (el.title + vendor) +
            "</div>" +
            itemPrice +
            "</div>"
        }

        suggestions +=
          '<li class="search-result-single" role="listitem" data-index="' +
          counter +
          '"><a id="' +
          (containerId + counter) +
          '" class="predictive-result" href="' +
          el.url +
          '">' +
          (thumbnail + itemTitle) +
          "</a></li>"

        counter++
      })
    }

    function handleResults(results) {
      suggestions = ""
      counter = 0

      if (results["queries"]) {
        compileResults(results["queries"], "queries")
      }

      if (results["collections"]) {
        compileResults(results["collections"], "suggestions")
      }

      if (results["products"]) {
        compileResults(results["products"], "products")
      }

      if (results["pages"]) {
        compileResults(results["pages"], "pages")
      }

      if (results["articles"]) {
        compileResults(results["articles"], "pages")
      }

      var searchHref = "/search?options%5Bprefix%5D=last&q=" + searchString
      var resultsDoSearch =
        '<li class="search-action search-result-single" role="listitem" data-index="' +
        counter +
        '">\n        <a class="button do-search" href="' +
        searchHref +
        '">' +
        translations.searchfor +
        '<span class="predictive-search-view-all__query"> ' +
        searchString +
        "</span></a></li>"
      suggestions += resultsDoSearch

      var resultsCount = Sunrise.strings.one_result_found
      if (counter != 1) {
        resultsCount = Sunrise.strings.number_of_results_found.replace("[results_count]", counter)
      }

      var resultsA11y =
        "<li aria-live='polite' role='status' class='visually-hidden search-results-count'>" + resultsCount + "</li>"
      suggestions = resultsA11y + suggestions

      targetDiv.querySelector(selectors.results).innerHTML = suggestions
      submitButtonIcon.classList.remove("animated-looped-fast", "pulse")
      wrapper.classList.add(classes.searchPopulated)
      wrapper.classList.remove(classes.hideResults)
      wrapper.setAttribute("data-resultcount", counter)
    }
  }

  // event listeners
  var searchKeyHandler = function searchKeyHandler(e) {
    toggleSearch(e, e.target)
  }

  var mainSearchField = document.querySelector(selectors.mainSearchField)
  if (mainSearchField) {
    mainSearchField.addEventListener(
      "input",
      Sunrise.Helpers.debounce(function (e) {
        doSearch(e.target)
      }, 200)
    )
  }

  var topSearchField = document.querySelector(selectors.topSearchField)
  if (topSearchField) {
    topSearchField.addEventListener(
      "input",
      Sunrise.Helpers.debounce(function (e) {
        doSearch(e.target)
      }, 200)
    )
  }

  document.addEventListener("focusin", function (e) {
    if (e.target.matches(selectors.mainSearchField)) {
      showMainSearch(e, e.target)
    }
  })

  document.addEventListener("click", function (e) {
    if (e.target.matches(".menu-search")) {
      showTopSearch(e)
    }

    if (e.target.matches(selectors.buttonClose)) {
      closeTopSearch(e)
    }

    if (e.target.matches(selectors.buttonReset)) {
      resetSearch(e, e.target)
    }

    if (!e.target.closest(selectors.searchFormWrap)) {
      // hide main search results when user clicks outside form
      if (document.querySelector(selectors.mainSearchWrapper)) {
        document.querySelector(selectors.mainSearchWrapper).classList.add(classes.hideResults)
      }
    }
  })

  document.addEventListener("change", function (e) {
    if (e.target.matches(selectors.searchField)) {
      searchKeyHandler(e)
    }
  })

  document.addEventListener("paste", function (e) {
    if (e.target.matches(selectors.searchField)) {
      searchKeyHandler(e)
    }
  })

  document.addEventListener("keyup", function (e) {
    if (e.target.matches(selectors.searchField)) {
      searchKeyHandler(e)
    }
  })

  document.addEventListener("keydown", function (e) {
    if (e.target.matches(selectors.searchField)) {
      focusFirstResult(e, e.target)
    }

    if (e.target.matches(".predictive-result") || e.target.matches(".do-search")) {
      navigateResults(e, e.target)
    }

    var topSearch = document.querySelector(selectors.topSearchWrapper)
    if (topSearch) {
      if (e.keyCode == keys.esc) {
        closeTopSearch(e)
      }
    }
  })
}

Sunrise.Testimonials = (function () {
  function Testimonials(container) {
    this.container = container
    this.slider = this.container.querySelector("[data-slider-testimonials]")
    if (!this.slider) return
    if (this.slider.dataset.count < 2) return

    this.options = {
      cellAlign: "left",
      contain: true,
      adaptiveHeight: true,
      prevNextButtons: false,
      autoPlay: 5000,
    }

    this.flkty = new Flickity(this.slider, this.options)
  }

  Testimonials.prototype = Object.assign({}, Testimonials.prototype, {
    onSectionLoad: function (e) {},
    onSectionUnload: function (e) {},
    onSelect: function (e) {},
    onDeselect: function (e) {
      if (this.options.autoPlay > 0 && this.slider.dataset.count > 1) {
        this.flkty.playPlayer()
      }
    },
    onBlockSelect: function (e) {
      this.flkty.stopPlayer()
      this.flkty.select(e.target.dataset.index)
    },
  })

  return Testimonials
})()

Sunrise.StoreAvailability = (function () {
  function StoreAvailability(container) {
    this.container = container
  }

  StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
    updateContent: function (variantId) {
      if (!this.container) {
        return
      }
      var variantSectionUrl =
        window.routes.rootUrlWithoutSlash + "/variants/" + variantId + "/?section_id=store-availability"
      var self = this

      // remove modal if it already exists
      var availabilityModal = document.getElementById("StoreAvailabilityModal-".concat(variantId))
      if (availabilityModal) {
        availabilityModal.remove()
      }

      fetch(variantSectionUrl)
        .then(function (response) {
          return response.text()
        })
        .then(function (storeAvailabilityHTML) {
          if (storeAvailabilityHTML.trim() === "") {
            return
          }
          self.container.innerHTML = storeAvailabilityHTML
          self.container.innerHTML = self.container.firstElementChild.innerHTML
          // append modal to body
          availabilityModal = document.getElementById("StoreAvailabilityModal-".concat(variantId))
          if (availabilityModal) {
            document.body.appendChild(availabilityModal)
          }
        })
    },

    clearContent: function () {
      this.container.innerHTML = ""
    },
  })

  return StoreAvailability
})()

Sunrise.initSections = function () {
  var sections = new Sunrise.Sections()
  sections.register("slideshow", Sunrise.Slideshow)
  sections.register("product", Sunrise.Product)
  sections.register("sidebar", Sunrise.Sidebar)
  sections.register("logo-list", Sunrise.LogoList)
  sections.register("featured-video", Sunrise.FeaturedVideo)
  sections.register("cart-template", Sunrise.Cart)
  sections.register("testimonials", Sunrise.Testimonials)
  sections.register("header", Sunrise.Header)
  sections.register("footer", Sunrise.Footer)
  sections.register("map", Sunrise.Maps)
}

Sunrise.initListeners = function () {
  var rootElement = document.documentElement

  window.addEventListener(
    "resize",
    Sunrise.Helpers.debounce(function () {
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth
      if (viewportWidth > 800) {
        document.body.classList.remove("small-screen")
        document.body.classList.add("two-column")
      } else {
        document.body.classList.add("small-screen")
        document.body.classList.remove("two-column")
      }
    }, 200)
  )

  window.addEventListener(
    "scroll",
    Sunrise.Helpers.debounce(function () {
      var scrollButton = document.querySelector(".xx-scroll-to-top")
      if (!scrollButton) {
        return
      }
      if (rootElement.scrollTop > 200) {
        document.body.classList.add("enable-back-to-top")
      } else {
        document.body.classList.remove("enable-back-to-top")
      }
    }, 200)
  )

  document.addEventListener(
    "click",
    function (e) {
      if (e.target.matches(".dropdown-toggle")) {
        handleDropdownToggle(e)
      }

      if (e.target.matches(".menu-button")) {
        e.preventDefault()
        showSidebar()
      }

      if (
        e.target.matches("input[name='checkout']") ||
        e.target.matches("input[name='goto_pp']") ||
        e.target.matches("input[name='goto_gc']")
      ) {
        var agreeTerms = document.querySelector("#agree-terms")
        if (agreeTerms) {
          // agree terms is active so make sure it's checked
          var isChecked = agreeTerms.querySelector("#agree").checked
          if (!isChecked) {
            e.preventDefault()
            alert(Sunrise.strings.agree_terms_popup_text)
            agreeTerms.classList.add("highlight")
            document.getElementById("agree").focus()
          }
        }
      }

      if (e.target.matches("a.go-back")) {
        e.preventDefault()
        window.location.href = document.referrer
      }

      if (e.target.matches(".xx-scroll-to-top")) {
        e.preventDefault()
        scrollToTop()
      }

      if (e.target.matches("button[data-modal-opener]")) {
        e.preventDefault()
        new Sunrise.modalHandler(e.target)
      }
    },
    false
  )

  document.addEventListener(
    "change",
    function (e) {
      if (e.target.matches("#BlogTagFilter")) {
        e.preventDefault()
        window.location.href = e.target.value
      }
    },
    false
  )

  Sunrise.Helpers.triggerEvent(window, "resize")
  Sunrise.Helpers.triggerEvent(window, "scroll")

  function showSidebar() {
    document.body.classList.toggle("active-nav")
    document.querySelector(".menu-button").classList.remove("active-button")
  }

  function handleDropdownToggle(e) {
    e.preventDefault()
    var subMenu = e.target.parentNode.nextElementSibling
    var closestLi = e.target.closest("li")
    var state = closestLi.classList.contains("active")

    state = !state
    closestLi.classList.toggle("active", state)
    e.target.setAttribute("aria-expanded", state)
  }

  function scrollToTop() {
    document.documentElement.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }
}

Sunrise.modalHandler = (function () {
  function Modal(opener) {
    // opener is the button that was clicked
    // get modal id from the button
    this.opener = opener
    this.modalId = this.opener.getAttribute("aria-controls")
    this.modal = document.getElementById(this.modalId)
    if (!this.modal) return false
    this.modalIsOpen = false
    this.openModal()
  }

  Modal.prototype.openModal = function (event) {
    // add click event for close button
    this.modal.querySelector("button.close-modal").addEventListener("click", this.closeModal.bind(this))

    // set aria attributes
    this.modal.setAttribute("aria-hidden", "false")

    // add class to body
    document.documentElement.classList.add("overflow-hidden")
    document.body.classList.add("overflow-hidden")

    // trap focus
    Sunrise.Helpers.trapFocus("#" + this.modalId + " .modal-drawer-content")

    this.modal.querySelector("button.close-modal").focus()
    this.modalIsOpen = true
    this.bindEvents()
  }

  Modal.prototype.closeModal = function () {
    if (!this.modalIsOpen) return
    // set aria attributes
    this.modal.setAttribute("aria-hidden", "true")
    // remove body class
    document.documentElement.classList.remove("overflow-hidden")
    document.body.classList.remove("overflow-hidden")
    // remove listeners for close button
    this.modal.querySelector("button.close-modal").removeEventListener("click", this.closeModal)
    // return focus to opener
    this.opener.focus()
    this.unbindEvents()
  }

  Modal.prototype.bindEvents = function () {
    this.keyupHandler = this.keyupHandler.bind(this)
    this.clickHandler = this.clickHandler.bind(this)
    document.body.addEventListener("keyup", this.keyupHandler)
    document.body.addEventListener("click", this.clickHandler)
  }

  Modal.prototype.unbindEvents = function () {
    document.body.removeEventListener("keyup", this.keyupHandler)
    document.body.removeEventListener("click", this.clickHandler)
  }

  Modal.prototype.keyupHandler = function (event) {
    if (event.keyCode === 27) {
      this.closeModal()
    }
  }

  Modal.prototype.clickHandler = function (event) {
    if (!this.modal.contains(event.target)) {
      this.closeModal()
    }
  }

  return Modal
})()

document.addEventListener("DOMContentLoaded", function () {
  /* Uses IntersectionObserver to
     Lazyload featured videos and the footer background image
     with fallback for non-supporting browsers */
  var lazyloadImages
  lazyloadImages = document.querySelectorAll(".lazy")

  if ("IntersectionObserver" in window) {
    var imageObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          if (entry.target.closest("iframe")) {
            // video so set src equal to data-src
            entry.target.src = entry.target.dataset.src
          }
          entry.target.classList.remove("lazy")
          imageObserver.unobserve(entry.target)
        }
      })
    })

    lazyloadImages.forEach(function (item) {
      imageObserver.observe(item)
    })
  } else {
    var lazyloadThrottleTimeout

    function lazyload() {
      if (lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout)
      }

      lazyloadThrottleTimeout = setTimeout(function () {
        var scrollTop = window.pageYOffset
        lazyloadImages.forEach(function (img) {
          if (img.offsetTop < window.innerHeight + scrollTop) {
            img.src = img.dataset.src
            img.classList.remove("lazy")
          }
        })
        if (lazyloadImages.length == 0) {
          document.removeEventListener("scroll", lazyload)
          window.removeEventListener("resize", lazyload)
          window.removeEventListener("orientationChange", lazyload)
        }
      }, 20)
    }

    document.addEventListener("scroll", lazyload)
    window.addEventListener("resize", lazyload)
    window.addEventListener("orientationChange", lazyload)
  }
})

// jQuery ready equivalent
var ready = function ready(callback) {
  if (document.readyState != "loading") callback()
  else document.addEventListener("DOMContentLoaded", callback)
}

Sunrise.init = function () {
  Sunrise.initListeners()
  Sunrise.initAccordions()
  Sunrise.initSections()
  Sunrise.customerTemplates.init()
  Sunrise.predictiveSearch()

  // Theme-specific selectors to make tables scrollable
  var tableSelectors = ".rte table," + ".custom__item-inner--html table"

  Sunrise.rte.wrapTable({
    tables: document.querySelectorAll(tableSelectors),
    tableWrapperClass: "scrollable-wrapper",
  })

  // Theme-specific selectors to make iframes responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"],' +
    '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
    '.custom__item-inner--html iframe[src*="player.vimeo"]'

  Sunrise.rte.wrapIframe({
    iframes: document.querySelectorAll(iframeSelectors),
    iframeWrapperClass: "video-wrapper",
  })

  document.addEventListener(
    "touchstart",
    function () {
      Sunrise.Helpers.setTouch()
    },
    { once: true }
  )

  // make sure slideshow is displayed properly on first load
  window.dispatchEvent(new Event("resize"))
}

ready(function () {
  Sunrise.init()
})
